<template>
  <div class="OrderManageCreate-root">
    <span v-if="odrNo && !oneMoreOrder" class="odr-txt">订单号 {{ odrNo }}</span>
    <a-form-model
        ref="orderForm"
        class="order-manage-create-page"
        :model="form"
        layout="horizontal"
        :rules="rules"
        :colon="false"
        :label-col="{span: 6}"
        :wrapper-col="{span: 18}"
    >
      <a-spin :spinning="loading.onSubmit">
        <a-space v-if='standardData' direction="vertical">
          <div>
            <div v-if="isEnterprise" class="contrat-container">
              <div class="projectTitle">
                <img src="@/assets/img/icon_fuwushang.png" alt="">
                <cutCarrier></cutCarrier>
              </div>
            </div>
            <div v-if="wisdomMileage" class="specialCarTips">
              <a-icon type="exclamation-circle"/>
              {{ tipsText }}
              <a-icon type="close" @click="wisdomMileage=false"/>
            </div>
            <div v-if="lineTips" class="specialCarTips">
              <a-icon type="exclamation-circle"/>
              目的地{{ lineIipsName }}与起始地相同，请确认
              <a-icon type="close" @click="lineTips=false"/>
            </div>
            <div class="order-container">
              <div class="basic-info">
                <a-row v-if="(form.productType === standardType.CP003 || form.productType === standardType.CP004)">
                  <a-col :md="8" :sm="12" class="radioBox">
                    <a-form-model-item
                        label="订单类型"
                        :label-col="{span: 6}"
                        :wrapper-col="{span: 16}"
                        prop="selectCode"
                        :rules="orderTypeRules"
                    >
                      <a-radio-group
                          v-model="selectCode"
                          :disabled="isEditPage"
                          class="radio-global"
                          @change="(event)=>{isTypeChange(event.target.value)}"
                      >
                        <a-radio v-for="cityCode in standardCityList" :key="cityCode.productCode"
                                 :value="cityCode.productCode"
                                 :class="selectCode === cityCode.productCode ? 'radioStyle noStyle' : 'noStyle'">
                          {{ cityCode.productName }}
                        </a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col v-if="fetchOrganization" :md="8" :sm="24" class="content">
                    <a-form-model-item
                        label="运营项目"
                        :colon="false"
                        prop="projectId"
                        :label-col="{span: 6}"
                        :wrapper-col="{span: 16}"
                    >
                      <order-select v-model="form.projectId" :list="projectList" :edit="isEditPage"
                                  @checkedList="checkedList" @onSearch="onSearchProject"/>
                      <div v-if="!projectALLData.length">
                        暂无运营项目，请联系管理员创建
<!--                        <a-button style="padding: 0" type="link" @click="toProject">创建运营项目</a-button>-->
                      </div>
                    </a-form-model-item>
                  </a-col>
<!--                  <a-col-->
<!--                      v-if="form.productType !== standardType.CP001 && form.productType !== standardType.CP002 && hasWarehouse"-->
<!--                      :md="8" :sm="24">-->
<!--                    <a-form-model-item-->
<!--                        label="运输类型"-->
<!--                        prop="transportTypeCar"-->
<!--                        :label-col="{span: 6}"-->
<!--                        :wrapper-col="{span: 16}"-->
<!--                    >-->
<!--                      <a-radio-group-->
<!--                          v-model="form.transportTypeCar"-->
<!--                          :disabled="isEditPage"-->
<!--                          class="radio-global"-->
<!--                          @change="onChangeTransport"-->
<!--                      >-->
<!--                        <a-radio :value="true" :class="form.transportTypeCar === true ? 'radioStyle' : ''">-->
<!--                          纯运输-->
<!--                        </a-radio>-->
<!--                        <a-radio :value="false" :class="form.transportTypeCar === false ? 'radioStyle' : ''">-->
<!--                          仓配一体-->
<!--                        </a-radio>-->
<!--                      </a-radio-group>-->
<!--                    </a-form-model-item>-->
<!--                  </a-col>-->
                </a-row>
                <a-row
                    v-if="(form.productType === standardType.CP001 || form.productType === standardType.CP003) && form.transportTypeCar">
                  <!-- <a-col
                                v-if="form.productType === standardType.CP003 || (mileage && form.isLine) || (form.productType === standardType.CP001 && form.isLine) && !isPretend"
                                :md="8"
                                :sm="24"
                                class="mileageKmBox"
                            >
                                <a-form-model-item
                                    label="预估里程"
                                    :label-col="{span: 6}"
                                    :wrapper-col="{span: 16}"
                                >
                                    <a-input-number
                                        v-model="form.mileageKm"
                                        placeholder="请输入预估线路里程"
                                        suffix="KM"
                                        class="orderNumStyle"
                                        :max="5000"
                                        :min="0"
                                        :formatter="limitDecimals"
                                        :parser="limitDecimals"
                                    />
                                    <span class="milStyle">KM</span>
                                    <a-tooltip>
                                        <template slot="title">
                                            若填写预估线路里程，整条线路统一按该里程计费
                                        </template>
                                        <a-icon class="tipsIcon" type="question-circle" />
                                    </a-tooltip>
                                </a-form-model-item>
                            </a-col> -->
                  <a-col :md="16" :sm="24" class="radioBox">
                    <a-form-model-item
                        label="线路下单"
                        :label-col="{span: 3}"
                        :wrapper-col="{span: 21}"
                    >
                      <a-radio-group v-model="form.isLine" :disabled="lineDisbled" class="radio-global"
                                     @change="isLineChange">
                        <a-radio :value="true" :class="form.isLine === true ? 'radioStyle noStyle' : 'noStyle'">
                          是
                        </a-radio>
                        <div v-if="form.isLine" class="siteBox">
                          <select-dom v-model="form.lineId" :list="lineList" :disabled="lineDisbled" :edit="true"
                                      :tips="true" @checkedList="changeLine" @onSearch="onSearchLine"/>
                        </div>
                        <a-radio :value="false" :class="form.isLine === false ? 'radioStyle noStyle' : 'noStyle'">
                          否
                        </a-radio>
                      </a-radio-group>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <div
                    v-if="(form.productType === standardType.CP001 || filterFeeItem(elementsCode.CARTYPE)) && form.productType !== standardType.CP002"
                    class="carBottom">
                  <div class="projectTitle">
                    <span>车型选择</span>
                    <!-- <a-radio-group
                                    v-if="(form.productType === standardType.CP003 || form.productType === standardType.CP004) && tenantFlag"
                                    v-model="form.carCityType"
                                    class="intelligence order-radio"
                                    @change="isCarChange"
                                >
                                    <a-radio :disabled="filterstand().includes(standardType.CP004) && !filterstand().includes(standardType.CP003)" :value="0">
                                    指定车型
                                    </a-radio>
                                    <a-radio :value="1">
                                    智能调度
                                    </a-radio>
                                </a-radio-group> -->
                  </div>
                  <car-type v-if="form.carNorms && filterCar()" v-model="form.carLength" class="" :list="carTypeList"
                            :car-norms="form.carNorms" @checkedList="changeCarType"></car-type>
                  <div
                      v-if="filterCar()"
                      class="car-specifications"
                  >
                    <span>车型规格</span>
                    <a-radio-group
                        v-if="form.carLength"
                        v-model="form.carNorms"
                        class="specifications-radio"
                        @change="changeCar"
                    >
                      <a-radio v-for="cartype in filertype()" :key="cartype.id" :value="cartype.carSettingName">
                        {{ cartype.carSettingName }}
                      </a-radio>
                    </a-radio-group>
                  </div>
                </div>
              </div>
              <block-title
                  v-if="!form.transportTypeCar"
                  class="basic"
                  title="基本信息"
                  icon-title="仓"
              >
                <div class="content">
                  <a-row>
                    <a-col :md="6" :sm="12">
                      <a-form-model-item
                          label="订单类型"
                          :label-col="{span: 8}"
                          :wrapper-col="{span: 16}"
                      >
                        <div v-if="isEditPage">
                          <span v-if="form.scene === warehouseType.in">入库</span>
                          <span v-else>出库</span>
                        </div>
                        <a-radio-group
                            v-else
                            v-model="form.scene"
                            class="radio-global"
                            @change="orderWarehouseChange($event.target.value, true)"
                        >
                          <a-radio :value="warehouseType.in" :disabled="true">入库</a-radio>
                          <a-radio :value="warehouseType.out">出库</a-radio>
                        </a-radio-group>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :md="6" :sm="12">
                      <a-form-model-item
                          :label="form.scene === warehouseType.in ? '入库仓库' : '出库仓库'"
                          :label-col="{span: 8}"
                          :wrapper-col="{span: 16}"
                          prop="deliverWarehouseCode"
                      >
                        <SelectDomWareHouse
                            v-if="listFlag"
                            v-model="form.deliverWarehouseCode"
                            :text="form.defultName"
                            :edit="isEditPage"
                            :list="warehouseList"
                            placeholder="请选择仓库"
                            @onSearch="onSearchWarehouse"
                            @checkedList="checkedWarehouse"
                            @remove="removeData"
                        />
                      </a-form-model-item>
                    </a-col>
                    <a-col :md="6" :sm="12">
                      <a-form-model-item
                          label="外部单号"
                          :label-col="{span: 8}"
                          :wrapper-col="{span: 16}"
                      >
                        <a-input
                            v-model="form.crmNumber"
                            :max-length="30"
                            placeholder="请输入外部单号"
                        />
                      </a-form-model-item>
                    </a-col>
                    <a-col :md="6" :sm="12">
                      <a-form-model-item
                          :label="form.scene === warehouseType.in ? '入库时间' : '出库时间'"
                          :label-col="{span: 8}"
                          :wrapper-col="{span: 16}"
                          prop="planTime"
                      >
                        <a-date-picker
                            v-model="form.planTime"
                            :show-time="{ defaultValue: defaultTime }"
                            :placeholder="form.scene === warehouseType.in ? '请选择入库时间' : '请选择出库时间'"
                        />
                      </a-form-model-item>
                    </a-col>
                    <a-col :md="6" :sm="12">
                      <a-form-model-item
                          :label="form.scene === warehouseType.in ? '入库类型' : '出库类型'"
                          :label-col="{span: 8}"
                          :wrapper-col="{span: 16}"
                          prop="type"
                      >
                        <a-select
                            v-model="form.type"
                            placeholder="请选择"
                        >
                          <a-select-option
                              v-for="item in form.scene === warehouseType.in ? filterList() : OUTTYPE"
                              :key="item.value"
                              :value="item.value"
                              :disabled="item.disabled"
                          >
                            {{ item.lable }}
                          </a-select-option>
                        </a-select>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <!-- <a-row>
                    <a-col :span="24">
                      <a-form-model-item
                          label="仓操作项"
                          :label-col="{span: 2}"
                          :wrapper-col="{span: 21}"
                          prop=""
                      >
                        <a-checkbox-group v-model="form.operateOptions" :options="warehouseOptions"/>
                      </a-form-model-item>
                    </a-col>
                  </a-row> -->
                </div>
              </block-title>
              <block-title
                  v-if="form.transportTypeCar && !isPretend"
                  class="origin-station"
                  title="发货地信息"
                  icon-title="发"
              >
                <StartStation
                    v-model="form.startStation"
                    :disabled="sameGroup"
                    :product-code="productCode"
                    :tenant-flag="tenantFlag"
                    subtitle="发货地信息"
                />
              </block-title>
              <!-- 多装多卸 -->
              <div v-if="form.transportTypeCar && isPretend">
                <div v-for="(startStation, i) in form.pretendStation" :key="i">
                  <block-title
                      v-if="form.transportTypeCar"
                      class="origin-station"
                      :title="`发货地信息${form.pretendStation.length > 1 ? i + 1 : ''}`"
                      icon-title="发"
                  >
                                <span v-if="form.pretendStation.length !== 1" slot="icon-right" class="deleteStyle"
                                      @click="onDeleteStartStation(i)">
                                    <a-icon type="delete"/>删除
                                </span>
                    <StartStation
                        v-model="form.pretendStation[i]"
                        :disabled="sameGroup"
                        :prop-prefix="`pretendStation.${i}`"
                        :product-code="productCode"
                        :tenant-flag="tenantFlag"
                        :is-pretend="isPretend"
                        :pretend-station="form.pretendStation"
                        subtitle="发货地信息"
                        @changeDetil="filterChangeDetil"
                    />
                  </block-title>
                </div>
              </div>
              <!-- 仓起始地 -->
              <block-title
                  v-if="!form.transportTypeCar"
                  class="origin-station"
                  title="起始地信息"
                  icon-title="发"
              >
                <StartStationWareHouse
                    v-model="form.startStation"
                    :type="form.type"
                    :scene="form.scene"
                    subtitle="起始地信息"
                    :deliver-warehouse-code="form.deliverWarehouseCode"
                    :customer-code="form.customerCode"
                    @change="changeStation"
                />
              </block-title>
              <!-- 仓配选择货品 -->
              <block-title v-if="!form.transportTypeCar && !isDischarge" title="货品信息">
                <GoodsInfoWareHouse
                    v-model="form.stationGoodsList"
                    :prop-prefix="`stationGoodsList`"
                    :scene="form.scene"
                    :deliver-warehouse-code="form.deliverWarehouseCode"
                    :shipper-code="form.customerCode"
                    :select-warehouseid="form.selectWarehouseid"
                />
              </block-title>
            </div>
            <div v-if="showStart" class="station-add startAdd">
              <a-button
                  v-if="form.pretendStation.length < 10 && !form.isLine"
                  block
                  type="link"
                  @click="onAddStartStation"
              >
                <a-icon type="plus"/>
                添加发货地
              </a-button>
            </div>
            <!-- 仓目的地 -->
            <div v-if="!form.transportTypeCar" class="block-container">
              <block-title
                  v-for="(station, index) in form.endStation"
                  :key="index"
                  class="destination"
                  :title="form.endStation.length > 1 ? `目的地信息${index+1}` : '目的地信息'"
                  icon-title="收"
              >
                <span
                  v-if="form.endStation.length !== 1"
                  slot="icon-right" class="deleteStyle"
                  @click="onDeleteEndStation(index,station)">
                  <a-icon type="delete"/>删除
                </span>
                <EndStationWareHouse
                    v-if="form.needTransport === 1 || isischarge"
                    v-model="form.endStation[index]"
                    :show-add-button="!isEditPage && form.endStation.length < 10"
                    :show-delete-button="!isEditPage && form.endStation.length !== 1"
                    :prop-prefix="`endStation.${index}`"
                    :scene="form.scene"
                    :deliver-warehouse-code="form.deliverWarehouseCode"
                    @add="onAddWharehouseEndStation"
                    @change="changeStation"
                    @delete="onDeleteEndStation(index)"
                >
                  <template v-if="isDischarge">
                    <GoodsInfoWareHouse
                      v-model="station.stationGoodsList"
                      :need-transport="form.needTransport"
                      :prop-prefix="`endStation.${index}.stationGoodsList`"
                      :scene="form.scene"
                      :deliver-warehouse-code="form.deliverWarehouseCode"
                      :shipper-code="form.customerCode"
                      :is-edit-page="isEditPage"
                      :one-more-order="oneMoreOrder"
                      :select-warehouseid="form.selectWarehouseid"
                      @afreshVali="handleAfreshVali"
                      @refreshAll="handleRefreshAll"
                    />
                </template>
                </EndStationWareHouse>
                <EndStationNoVerification
                    v-else
                    v-model="form.endStation[0]"
                    :show-add-button="!isEditPage && form.endStation.length < 10"
                    :show-delete-button="!isEditPage && form.endStation.length !== 1"
                    :scene="form.scene"
                    :deliver-warehouse-code="form.deliverWarehouseCode"
                    @add="onAddEndStation"
                    @change="changeStation"
                    @delete="onDeleteEndStation(0)"
                />
              </block-title>
            </div>
            <div
              v-if="!form.transportTypeCar && isDischarge"
              class="station-add">
              <a-button
                v-if="form.endStation.length < 30 && !form.isLine"
                block
                type="link"
                @click="onAddEndStation"
              >
                <a-icon type="plus"/>
                添加收货地
                </a-button>
            </div>
            <div v-if="form.transportTypeCar">
              <div
                  v-for="(endStation, endStationIndex) in form.endStation"
                  :key="endStationIndex"
                  class="block-container"
              >
                <block-title
                    class="destination"
                    :title="`收货地信息${endStationIndex+1}`"
                    icon-title="收"
                >
                            <span v-if="form.endStation.length !== 1" slot="icon-right" class="deleteStyle"
                                  @click="onDeleteEndStation(endStationIndex,endStation)">
                                <a-icon type="delete"/>删除
                            </span>
                  <EndStation
                      v-model="form.endStation[endStationIndex]"
                      :show-add-button="form.endStation.length < 10"
                      :show-delete-button="form.endStation.length !== 1"
                      :prop-prefix="`endStation.${endStationIndex}`"
                      :subtitle="form.endStation.length === 1 ? '收货地信息' : `收货地信息${endStationIndex + 1}`"
                      :standard-data="standardData"
                      :lineorder="form.isLine"
                      :disabled="createDisabled()"
                      :end-station-index="endStationIndex === form.endStation.length - 1"
                      :product-code="productCode"
                      :tenant-flag="tenantFlag"
                      :start-station="form.startStation"
                      :is-pretend="isPretend"
                      :pretend-station="form.pretendStation"
                      :end-station-list="form.endStation"
                      @removePrice="removePrice"
                      @changeDetil="changeStation"
                      @add="onAddEndStation"
                      @delete="onDeleteEndStation(endStationIndex, endStation)">
                    <GoodsInfo
                        v-if="standardList.length > 0 && goodsFlag"
                        v-model="endStation.stationGoodsList"
                        :title="'货品信息'"
                        :prop-prefix="`endStation.${endStationIndex}.stationGoodsList`"
                        :standard-index="form.productType"
                        :standard-list="standardList"
                        :is-pretend="isPretend"
                        :product-code="productCode"
                        :pretend-station="form.pretendStation"
                        :order-goods-type="endStation.orderGoodsType"
                        :end-station="form.endStation[endStationIndex]"
                        :is-edit-page="isEditPage"
                        :start-num="startNum"
                        @orderGoodsTypeChange="(value) => { orderGoodsTypeChange(value, endStation, endStationIndex) }"
                        @changeShipment="changeShipment"
                        @afreshVali="handleAfreshVali"
                    />
                  </EndStation>
                </block-title>
              </div>
            </div>
            <div
                v-if="(form.endStation.length < 10 || form.endStation.length !== 1) && !(form.carCityType === 1 && !filterstand().includes(standardType.CP004)) && form.transportTypeCar"
                class="station-add">
              <a-button
                  v-if="form.endStation.length < 10 && !form.isLine"
                  block
                  type="link"
                  @click="onAddEndStation"
              >
                <a-icon type="plus"/>
                添加收货地
              </a-button>
            </div>
            <div class="block-container">
              <block-title title="其他信息">
                <a-row>
                  <a-col v-if="isParentMark"  :md="8" :sm="24">
                  <a-form-model-item
                      :colon="false"
                      :label-col="{span: 6}"
                      :wrapper-col="{span: 16}"
                  >
                  <template #label>
                   <div class="zimu_table">
                      <span>子母单标识</span>
                      <el-tooltip
                        content="非必填，相同子母单标识的订单，将合并计费"
                        placement="top"
                      >
                        <i class="el-icon-question"></i>
                      </el-tooltip>
                    </div>
                  </template>
                     <a-select
                      v-model="form.bdstNumber"
                      show-search
                      allow-clear
                      :options="orderMarkList"
                      placeholder="选择子母单标识"
                    >
                    </a-select>
                  </a-form-model-item>
                </a-col>
                  <!-- <a-col v-if="form.productType === standardType.CP002" :md="6" :sm="24">
                                <a-form-model-item
                                    label="是否提货"
                                    :label-col="{span: 6}"
                                    :wrapper-col="{span: 16}"
                                >
                                    <a-radio-group v-model="form.needPickUp" order-radio>
                                        <a-radio :value="true" :class="form.needPickUp === true ? 'radioStyle' : ''">
                                        是
                                        </a-radio>
                                        <a-radio :value="false" :class="form.needPickUp === false ? 'radioStyle' : ''">
                                        否
                                        </a-radio>
                                    </a-radio-group>
                                </a-form-model-item>
                            </a-col>
                            <a-col v-if="form.productType === standardType.CP002" :md="8" :sm="24">
                                <a-form-model-item
                                    label="是否配送"
                                    :label-col="{span: 6}"
                                    :wrapper-col="{span: 16}"
                                >
                                    <a-radio-group v-model="form.needDelivery" order-radio>
                                        <a-radio :value="true" :class="form.needDelivery === true ? 'radioStyle' : ''">
                                        是
                                        </a-radio>
                                        <a-radio :value="false" :class="form.needDelivery === false ? 'radioStyle' : ''">
                                        否
                                        </a-radio>
                                    </a-radio-group>
                                </a-form-model-item>
                            </a-col> -->
                  <a-col
                      v-if="isShowCustomeField(ORDER_CUSTOME_FIELDS.mileageKm)&&(form.productType === standardType.CP003 || mileage || form.productType === standardType.CP001) && isPretend"
                      :md="8" :sm="24">
                    <a-form-model-item
                        label="预估里程"
                        :colon="false"
                        :label-col="{span: 6}"
                        :wrapper-col="{span: 16}"
                    >
                      <a-input-number v-model="form.mileageKm" suffix="KM" class="orderNumStyle" :max="5000" :min="0"
                                      :formatter="limitDecimals" :parser="limitDecimals" placeholder="请输入预估里程"/>
                      <span> KM</span>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-if="isShowCustomeField(ORDER_CUSTOME_FIELDS.crmNumber)&&form.transportTypeCar" :md="8" :sm="24">
                    <a-form-model-item
                        label="外部订单号"
                        :colon="false"
                        :label-col="{span: 6}"
                        :wrapper-col="{span: 16}"
                    >
                      <a-input v-model="form.crmNumber" class="orderNumStyle" placeholder="请输入外部订单号"/>
                    </a-form-model-item>
                  </a-col>
                  <a-col v-if="filterFeeItem(elementsCode.CHANNEL)" :md="8" :sm="24">
                    <a-form-model-item
                        label="销售渠道"
                        :colon="false"
                        :label-col="{span: 6}"
                        :wrapper-col="{span: 16}"
                    >
                      <a-input v-model="form.orderLabel" class="orderNumStyle" :max-length="30" placeholder="请输销售渠道"/>
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col :md="12" :sm="24">
                    <a-form-model-item
                        label="备注"
                        :colon="false"
                        :label-col="{span: 4}"
                        :wrapper-col="{span: 17}"
                    >
                      <a-input
                          v-model="form.remark"
                          :max-length="100"
                          :auto-size="{ minRows: 3, maxRows: 3 }"
                          class="remark-input"
                          placeholder="请输入，最多不超100字"
                          type="textarea"/>
                    </a-form-model-item>
                  </a-col>
                </a-row>
              </block-title>
            </div>
            <!-- 不在合同范围内，走一单一议 零担没有一单一议 -->
            <div v-if="isSingleArgument && !isWithinTheContract && productCode !== standardType.CP002" class="block-container freight">
              <block-title title="其他信息">
                <a-form-model-item
                    label="参考运费"
                    :label-col="{span: 2}"
                    :wrapper-col="{span: 17}"
                >
                  <span class="moneyText">¥</span>
                  <span class="amount">{{ calculationPrice }}</span>
                  <span class="ytips">友情提示：出价如果低于参考运费可能没有司机接单</span>
                </a-form-model-item>
                <a-form-model-item
                    label="我的出价"
                    :label-col="{span: 2}"
                    :wrapper-col="{span: 17}"
                >
                  <a-input v-model.number="form.bidPrice" class="inputStyle" type="number" @change="changePrice"/>
                  <a-select v-model="form.bidUnit" style="width: 120px">
                    <a-select-option v-for="text in bidUnitList" :key="text" :value="text">
                      {{ text }}
                    </a-select-option>
                  </a-select>
                </a-form-model-item>
                <a-form-model-item
                    label="总价"
                    :label-col="{span: 2}"
                    :wrapper-col="{span: 17}"
                >
                  <span class="moneyText">¥</span>
                  <span class="amount">{{ form.customerBidCost }}</span>
                </a-form-model-item>
                <a-form-model-item
                    label="自动确认"
                    :label-col="{span: 2}"
                    :wrapper-col="{span: 17}"
                >
                  <a-switch v-model="form.autoConfirm"/>
                  <span class="automatic">司机报价低于或等于我的出价时订单自动确认</span>
                </a-form-model-item>
              </block-title>
            </div>
          </div>
        </a-space>
      </a-spin>
    </a-form-model>
    <fix-bottom class="create-btns">
      <template slot="button">
        <a-button v-track-click="{ trackName: `在线下单-${standardTypeText[productCode]}-取消下单` }" @click="closeOrder">
          取消
        </a-button>
        <a-button
            v-track-click="{ trackName: isEditPage ? `在线下单-${standardTypeText[productCode]}-编辑订单` : `在线下单-${standardTypeText[productCode]}-提交订单`  }"
            v-auth="$_ButtonPermission.ORDER_PLACEORDER"
            class="margin-left"
            type="primary"
            :loading="upLoading"
            @click="onSubmit"
        >
          {{ isEditPage ? '保存' : '提交订单' }}
        </a-button>
        <p v-if="isEnablePricing && isWithinTheContract && filterCode() && tenantFlag" class="money">
          <span class="total">运费合计:</span>
          <span class="moneyText">{{ form.estimatePrice ? `￥${form.estimatePrice}` : '' }}</span>
          <span v-if="pricing && !form.estimatePrice" class="amount">计价中</span>
        </p>
      </template>
    </fix-bottom>
    <!-- 里程小于200提示框 -->
    <a-modal
        :visible="visible"
        @ok="toCity()"
        @cancel="visible = false"
    >
      <p class="intelligence mLeft">
        <a-icon type="exclamation-circle"/>
        智能策略推荐
      </p>
      <p class="intellText">{{ tipsText }}</p>
    </a-modal>
    <!-- 里程大于200提示框 -->
    <a-modal
        :visible="specialFlag"
        @ok="toSpecial()"
        @cancel="specialFlag = false"
    >
      <p class="intelligence mLeft">
        <a-icon type="exclamation-circle"/>
        智能策略推荐
      </p>
      <p class="intellText">{{ tipsText }}</p>
    </a-modal>
    <div v-if="noAuthentication" class="maks" @click="authFlag = true">
      <auth v-if="authFlag" @success="authSuccess" @cancel="authFlag = false"></auth>
    </div>
    <!-- 多装多卸未选择的起始地 -->
    <a-modal
        title="发货地信息为空提醒"
        :visible="noPretedSelect"
        @ok="submitPretend"
        @cancel="closePretend"
    >
      <p v-for="item in noSelect" :key="item.address" class="noPreteStyle">{{ item.address }}</p>
      <span class="noPreteStyle">-发货地未关联货品</span>
      <span>，你还要继续吗？</span>
    </a-modal>
    <err-batch ref="errBatch" :is-discharge.sync="isDischarge" @changeGoods="changeGoods" @changeDischargeGoods="changeDischargeGoods"/>
    <settlementModes ref="settlementModes"/>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment';
import loadingMixin from '@thales/loading'
import FormValidator from '@/constants/formValidator'
import FixBottom from '@/components/fix-bottom/index.vue';
import {TransportType} from '@/pages/orderManage/constant'
import SelectDom from '@/components/select/SelectDom'
import OrderSelect from '@/components/select/OrderSelect.vue'
import setScrollTop from '@/utils/scroll'
import BlockTitle from '@/components/panel/BlockTitle.vue'
import Auth from '@/components/authentication/Auth.vue'
// import baseApi from '@/api/base.js'
import {ORDER_CUSTOME_FIELDS} from '@/constants/ruleConfig'
import settlementModes from '@/components/settlementModes/index.vue'
import {
  createStandardOrder, featchOrderDetailUnify, updateStandardOrder,
  fetchProject, getStandCarType, getInterface, getCarLine, getConfig,
  getStations, getDistance, getPrice, getZeroEnd, getZeroStart, getTenantSting, getWareHouseContract,
  createManyStandardOrder, getManyPrice, getManyZeroEnd, updateStandardEditUnify, getNoRYCarLine, parentMarkList
} from '../api.js'
import {
  getWareHouse,
  getCustomerList,
  createWarehouseOrder,
  getOrderDetail,
  updateWarehouseOrder,
  createWarehouseMultipleOrder
} from '../../warehouseOrder/api.js'
import {INTYPE, INTYPECODE, OUTTYPE, OUTTYPECODE} from '../../warehouseOrder/warehouseCreate/constant.js'
import GoodsInfo from './components/GoodsInfo'
import StartStation from './components/StartStation'
import EndStation from './components/EndStation'
import CarType from './components/CarType.vue'
import GoodsInfoWareHouse from '../../warehouseOrder/warehouseCreate/components/GoodsInfo.vue'
import EndStationWareHouse from '../../warehouseOrder/warehouseCreate/components/EndStation.vue'
import EndStationNoVerification from '../../warehouseOrder/warehouseCreate/components/EndStationNoVerification.vue'
import StartStationWareHouse from '../../warehouseOrder/warehouseCreate/components/StartStation.vue'
import SelectDomWareHouse from '../../warehouseOrder/warehouseCreate/components/SelectDom.vue'
import ErrBatch from '../../warehouseOrder/warehouseCreate/components/ErrBatch.vue'
import cutCarrier from '../components/cutCarrier.vue'

const tationTypeCode = {
  start: 0, // 起始地
  end: 1, // 目的地
  startEnd: 2 // 起始地加目的地
}

const GOODS = {
  skuId: '',
  skuName: '',
  number: '',
  weight: '',
  volume: '',
  skuUnit: '',
  temperatureZone: '',
  goodsValue: '',
  shipment: '',
  startStationAddress: ''
}

const END_STATION = {
  stationId: '',
  stationCode: '',
  contactName: '',
  contactPhone: '',
  provinceName: '',
  cityName: '',
  countyName: '',
  address: '',
  expectTime: null,
  // crmNumber: '',
  defaultAddress: [],
  mileageKm: '',
  orderGoodsType: 1,
}

const START_STATION = {
  stationId: '',
  contactName: '',
  contactPhone: '',
  expectTime: null,
  provinceName: '',
  cityName: '',
  countyName: '',
  address: '',
  defaultAddress: []
}

const standardType = {
  CP001: 'CP001',
  CP002: 'CP002',
  CP003: 'CP003',
  CP004: 'CP004',
}
const standardTypeText = {
  CP001: '干线专车',
  CP002: '干线零担',
  CP003: '城配',
  CP004: '城配',
}

const elementsCode = {
  MILEAGE: 'mileage',  // 里程
  CARTYPE: 'carType',  // 车型
  CHANNEL: 'orderLabel',  // 销售渠道
}

const bidUnitList = ['元/单', '元/吨', '元/方']
const CANCELED = 'CANCELED'
const carCityTypeNum = 0

const warehouseType = {
  in: 'STORE',
  out: 'DELIVER'
}

const SCENE = {
  'DELIVER_ONLY': 'DELIVER_ONLY',            // 出库
  'DELIVER_TRANSPORT': 'DELIVER_TRANSPORT',  // 出库运输
  'STORE_ONLY': 'STORE_ONLY',  // 入库运输
  'STORE_TRANSPORT': 'TRANSPORT_STORE',  // 入库运输
  'DELIVER_STORE': 'DELIVER_STORE',  // 仓内调拨
  'DELIVER_TRANSPORT_STORE': 'DELIVER_TRANSPORT_STORE',  // 仓间调拨
}
const STARTSTATION = {
  stationId: '',
  contactName: '',
  contactPhone: '',
  expectTime: null,
  provinceName: '',
  cityName: '',
  countyName: '',
  address: '',
}
const ENDSTATION = {
  stationId: '',
  contactName: '',
  contactPhone: '',
  provinceName: '',
  cityName: '',
  countyName: '',
  address: '',
  expectTime: null,
}
const scenceType = {
  STORE: {
    1: SCENE.STORE_TRANSPORT,
    0: SCENE.STORE_ONLY,
  },
  DELIVER: {
    1: SCENE.DELIVER_TRANSPORT,
    0: SCENE.DELIVER_ONLY
  }
}
const odrChannel = 15

// 产品议价合同
const NEGOTIABLE = 'NEGOTIABLE'

export default {
  name: 'OrderManageCreate',
  components: {
    GoodsInfo,
    StartStation,
    EndStation,
    SelectDom,
    FixBottom,
    CarType,
    BlockTitle,
    Auth,
    GoodsInfoWareHouse,
    EndStationWareHouse,
    EndStationNoVerification,
    StartStationWareHouse,
    SelectDomWareHouse,
    ErrBatch,
    cutCarrier,
    OrderSelect,
    settlementModes,
  },
  mixins: [loadingMixin],
  props: {
    productCode: {
      type: String,
      default: ''
    },
    hasWarehouse: {
      type: Boolean,
      defalut: false
    },
    isDischarge:{
      type: Boolean,
      defalut: false
    }
  },
  inject: ['order'],
  data() {
    const validatorData = (rule, value, callback)=>{
      if(!this.selectCode){
        callback('请选择订单类型')
      }else if(!this.standardCityList.some(item=>item.productCode===this.selectCode)){
       callback('请选择订单类型')
      }
      callback()
    }
    return {
      hasStandard: true,
      warehouseType,
      ORDER_CUSTOME_FIELDS,
      isEnterprise: false,
      SCENE,
      OUTTYPE,
      bidUnitList,
      bottom: 0,
      loading: {
        onSubmit: false
      },
      FormValidator,
      isEditPage: false,
      oneMoreOrder: false,
      odrNo: '',
      TransportType,
      startTime: null, // 编辑时需要保存返回的起始地取货时间
      form: {
        projectId: '',
        projectName: '',
        parentId: '',
        startStation: {
          stationId: '',
          contactName: '',
          contactPhone: '',
          expectTime: null,
          provinceName: '',
          cityName: '',
          countyName: '',
          address: '',
          defaultAddress: []
        },
        endStation: [
          {
            ...END_STATION,
            stationGoodsList: [{...GOODS}]
          }
        ],
        pretendStation: [START_STATION],
        needHandling: false,
        remark: '',
        isLine: false,
        lineId: '',
        lineName: '',
        lineRemark: '',
        carTypeName: '',
        carTypeId: '',
        carLength: '',
        mileageKm: '',
        needPickUp: false,
        needDelivery: false,
        productType: '',
        crmNumber: '',
        bidPrice: null,
        carNorms: '',
        bidUnit: bidUnitList[0],
        customerBidCost: '',
        autoConfirm: false,
        estimatePrice: '',
        carCityType: 0, // 指定车型 0 和 智能调度 1
        transportTypeCar: true,
        scene: 'DELIVER',
        deliverWarehouseCode: '',
        defultName: '',
        planTime: '',
        type: INTYPECODE.order, // 入库类型
        library: false,
        // operateOptions: [],
        stationGoodsList: [],
        needTransport: 1,
        needShelves: false,
        transportType: TransportType.RUCKLOAD,
        orderLabel: ''
      },
      rules: {
        startStation: {
          expectTime: [
            {required: true, message: '请选择需要取货时间', trigger: 'change'},
          ],
        },
        // projectId: [
        //   {required: true, message: '请选择项目', trigger: 'change'},
        // ],
      },
      orderTypeRules:[{required: true,validator:validatorData , trigger: 'blur'}],
      endStations: [],
      projectList: [],
      accountData: {},
      selectAll: true,
      projectALLData: [],
      standardType,
      standardIndex: standardType.CP001,
      standardTypeText,
      carTypeList: {},
      allCarTypeList: [],
      standardList: [],
      lineList: [],
      elementsCode,
      sameGroup: false, // 是否同组
      upLoading: false,
      carTypeflag: false,
      visible: false,  // 专车和零担智能测略弹窗
      wisdomMileage: false,  // 顶部常驻智能策略提示
      first: true,  // 专车或零担弹窗是否第一次弹出
      isWithinTheContract: true, // 是否在合同范围内
      calculationPrice: '', // 一单一议参考运费
      pricing: false, // 是否在计价中
      specialFlag: false,  // 城配智能测略弹窗
      tipsText: '预估里程低于200KM，推荐你选择【城配】发货更优惠',
      cityFlag: false,  // 城配智能策略切换tab时判断切换专车或者零担
      standLineFlag: true,  // 区域配弹窗是否第一次弹出
      standAudioFlag: true, // 点位配弹窗是否第一次弹出
      tenantFlag: true, // 是否是平台租户
      standardCityList: [],
      selectCode: '',
      lineTips: false,
      lineIipsName: '',
      noAuthentication: false, // 未认证
      authFlag: false,
      isLoadingAndUnloadingMuch: false, // 编辑时返回的是否是多装多卸 如果是 不进行一单一议和预计费处理
      lineDisbled: false,
      warehouseList: [],
      listFlag: false,
      defaultTime: moment('00:00:00', 'HH:mm:ss'),
      warehouseContract: null,
      // warehouseOptions: [],
      isPretend: true, // 是否多装多卸白名单
      goodsFlag: true,
      noPretedSelect: false,
      noSelect: [],
      changeDetil: '',
      startNum: [],
      fetchOrganization: false,
      orderMarkList:[], // 子母单
      isSingleArgument: false, // 一单一议白名单
    }
  },
  computed: {
    ...mapState('orderRules', ['orderRules']),
    ...mapGetters('orderRules', ['isOrderDemoVersion']),
    standardData() {
      if (!this.standardList && this.standardList.length <= 0) return null
      let data = {elements: []}
      this.standardList.forEach((e) => {
        if (e.productCode === this.form.productType) {
          data = e
        }
      })
      return data
    },
    mileage() {
      if (!this.standardData) return false
      let flag = false
      this.standardData.elements.forEach((e) => {
        if (e.code === elementsCode.MILEAGE) {
          flag = true
        }
      })
      return flag
    },
    standardFeeItem() {
      // 产品要素code集合
      if (!this.standardData) return false
      return this.standardData.elements.map((e) => {
        return e.code
      })
    },
    showStart() {
      if (this.productCode === standardType.CP001) {
        let negotiationType = ''
        this.standardList.forEach(item => {
          if (item.productCode === standardType.CP001) {
            negotiationType = item.negotiationType
          }
        })
        return (this.form.pretendStation.length < 10 || this.form.pretendStation.length !== 1)
            && !(this.form.carCityType === 1 && !this.filterstand().includes(standardType.CP004))
            && this.form.transportTypeCar && negotiationType !== NEGOTIABLE
      }
      return (this.form.pretendStation.length < 10 || this.form.pretendStation.length !== 1)
          && !(this.form.carCityType === 1 && !this.filterstand().includes(standardType.CP004))
          && this.form.transportTypeCar
    },
    isEnablePricing(){
      // 是否启用预计费
      return (this.productCode !== standardType.CP001 || (this.productCode === standardType.CP001 && this.isSingleArgument)) && !!this.orderRules.BEFORE_PRICING.flag
    },
    isShowCustomeField(){
      // 判定自定义字段是在配置内
      return (field)=>{
        const {CUSTOM_FIELDS} = this.orderRules;
        return this.form.transportTypeCar?CUSTOM_FIELDS.fields.includes(field):true
      }
    },
    isParentMark(){
      // 子母单标识
      const {PARENT_ORDER_MARK} = this.orderRules;
      return !!PARENT_ORDER_MARK.flag
    },
  },
  watch: {
    productCode(val) {
      this.form.transportTypeCar = true;
      // this.form.productType = val;
      if ((this.productCode === standardType.CP003 || this.productCode === standardType.CP004) && !this.tenantFlag) {
        this.selectCode = this.standardCityList[0].productCode
      }
      this.isTypeChange(val)
    },
    form: {
      handler() {
        // 预计费
        if (this.order.ruyeWhite) {
          return
        }
        if ((this.productCode === standardType.CP001 || this.productCode === standardType.CP002) && this.tenantFlag) {
          setTimeout(() => {
            this.getPrice()
          }, 200)
        } else {
          this.isWithinTheContract = true
        }
        // 一单一议计算总价
        if (!this.isWithinTheContract) {
          this.totalPrice()
        }
      },
      deep: true
    },
    "form.startStation": function (val) {
      // if (val.address && (this.filterstand().includes(standardType.CP003) || this.filterstand().includes(standardType.CP004))) {
      //   this.getDistance({})
      // }
      if (val.address && this.productCode === standardType.CP002) {
        // 零担校验所选地址是否在配送范围
        this.zeroStartStation()
      }
    },
    "form.startStation.contactName": function () {
      this.lineTips = false
    },
    "form.startStation.contactPhone": function () {
      this.lineTips = false
    },
    "form.endStation": function () {
      // 有城配才有智能策略
      // let flag = true
      // val.forEach((e) => {
      //   if (!e.address) {
      //     flag = false
      //   }
      // })
      // if (flag && this.form.startStation.address && (this.filterstand().includes(standardType.CP003) || this.filterstand().includes(standardType.CP004))) {
      //   // 计算里程智能策略 仓配一体没有智能策略
      //   this.getDistance({})
      // }
      if (this.productCode === standardType.CP002) {
        // 零担校验所选地址是否在配送范围
        this.zeroEndStation()
      }
      // if (this.isPretend && flag && (this.filterstand().includes(standardType.CP003) || this.filterstand().includes(standardType.CP004))) {
      //   // 多装多卸
      //   // 计算里程智能策略 仓配一体没有智能策略
      //   this.getDistance({})
      // }
    },
    "form.pretendStation": function (val) {
      // 多装多卸起始地改变后 目的地选择的起始地要清空
      const address = val.map((e) => {
        return e.address
      })
      this.form.endStation.forEach((end, i) => {
        end.stationGoodsList.forEach((goods, n) => {
          if (!address.includes(goods.shipment)) {
            if (this.changeDetil !== '') {
              this.form.endStation[i].stationGoodsList[n].shipment = this.changeDetil.address
              this.form.endStation[i].stationGoodsList[n].startStationAddress = `${this.changeDetil.province}${this.changeDetil.city}${this.changeDetil.county}${this.changeDetil.address}`
            } else {
              this.form.endStation[i].stationGoodsList[n].shipment = ''
              this.form.endStation[i].stationGoodsList[n].startStationAddress = ''
            }
            if (!this.startNum.includes(this.form.endStation[i].stationGoodsList[n].shipment)) {
              this.form.endStation[i].stationGoodsList[n].orderNo = null
            }
          }
        })
      })
      this.goodsFlag = false
      this.$nextTick(() => {
        this.goodsFlag = true
      })

      // 计算里程智能策略 仓配一体没有智能策略
      // if (address.length > 0 && (this.filterstand().includes(standardType.CP003) || this.filterstand().includes(standardType.CP004))) {
      //   this.getDistance({})
      // }
    },
  },
  async created() {
    const {creditCode} = this.$store.state.user
    this.isEnterprise = !!creditCode
    this.noAuthentication = !this.$store.state.user.customerId
    this.getOrganization()
    this.getSingleArgumentList();
    this.form.productType = this.productCode
    await this.getInterface()
    this.accountData = JSON.parse(localStorage.getItem('accountData'));
    this.form.parentId = this.accountData.id
    if (this.productCode !== standardType.CP002) {
      await this.getCarType()
    }
    this.init()
    const res = await getTenantSting()
    // 判断是不是平台租户
    if (res.tenantId !== this.$store.state.user.tenantId) {
      this.tenantFlag = false
    }
    // 仓下单需要数据
    this.accountData = JSON.parse(localStorage.getItem('accountData'));
    this.form.parentId = this.accountData.id
    if(this.order.isProjectControl) {
      this.rules = {
        ...this.rules,
        projectId: [
          {required: true, message: '请选择项目', trigger: 'change'},
        ]
      }
    }
    if(this.isParentMark){
      // 子母单
      this.getParentMarkList()
    }
  },
  beforeRouteEnter(to, from, next) {
    setScrollTop()
    next(mv => {
      const authority = mv.$store.state.user.companyType
      if (!authority) {
        mv.$router.go(-1)
      }
    })
  },
  beforeDestroy() {
  },
  methods: {
    async getSingleArgumentList() {
      const req = await getConfig({
        keys: ['oms.single.argument'],
        appId: 1004
      })
      const list = req.configs[0]?.value.split(',') || ''
      if(list.includes(this.$store.state.user.customerCode)){
        this.isSingleArgument = true
      }
    },
    async getParentMarkList() {
      // 子母单列表获取
      const {tenantId, customerCode} = this.$store.state.user
      const res = await parentMarkList({
        customerCode,
        tenantId,
        statuses: ['ENABLE'],
      });
      if(res&&res.length){
        this.orderMarkList = res.map(item=>({value:item.code,label:item.code}))
      }else{
        this.orderMarkList = [];
      }
    },
    toProject() {
      this.$router.push('/organization')
    },
    changeGoods(list) {
      this.form.stationGoodsList = list
    },
    changeDischargeGoods(list){
      const {endStation}=this.form;
      const newEndStation= endStation.map(item=>{
        const goodsList=list.filter(goods=>goods.stationId===item.stationId)
        return {...item,stationGoodsList:goodsList}
      })
      this.$set(this.form,'endStation',newEndStation)
    },
    filterChangeDetil(data) {
      this.changeDetil = data
      this.changeStation()
    },
    closePretend() {
      this.noPretedSelect = false
      this.upLoading = false
    },
    // 多装多卸目的地选择起始地时校验智能策略
    changeShipment() {
      // this.getDistance({index, endData})
    },
    onAddStartStation() {
      this.form.mileageKm=null;
      this.form.pretendStation.push(JSON.parse(JSON.stringify(START_STATION)))
    },
    // async getOptions() {
    //   const list = await baseApi.getDictionary({
    //     status: 1,
    //     type: 'operateOptions',
    //   })
    //   this.warehouseOptions = list.map(res => ({
    //         label: res.dictionaryName,
    //         value: res.dictionaryCode
    //       })
    //   )
    // },
    orderWarehouseChange(value, issScene) {
      // 切换出入库类型，清空选择的货品信息
      if (issScene) {
        this.form.stationGoodsList = []
        if (this.form.scene === warehouseType.in) {
          this.getWareHouse(this.customerCodes, null, true)
          this.form.type = INTYPECODE.order
        } else {
          const code = this.getCode()
          this.getWareHouse(code, null, true)
          this.form.type = OUTTYPECODE.order
          this.$nextTick(() => {
            this.form.endStation = [ENDSTATION];
          })
        }
        this.form.deliverWarehouseCode = ''
        this.form.deliverWarehouseName = ''
        this.form.customerCode = ''
        this.form.customerId = ''
        this.form.customerName = ''
      } else {
        const {startStation, endStation} = this.form;
        this.form.startStation = {...STARTSTATION};
        this.form.endStation = [ENDSTATION];
        this.$nextTick(() => {
          this.form = {
            ...this.form,
            startStation,
            endStation,
          }
        })
      }
    },
    changeStation() {
      this.form.mileageKm = null;
      this.$refs.orderForm.clearValidate()
    },
    onChangeTransport() {
      this.$set(this.form, 'startStation', {
        stationId: '',
        contactName: '',
        contactPhone: '',
        expectTime: null,
        provinceName: '',
        cityName: '',
        countyName: '',
        address: '',
        defaultAddress: []
      })
      this.$set(this.form, 'endStation', [
        {
          ...END_STATION,
          stationGoodsList: [{...GOODS}]
        }
      ])
      this.$set(this.form, 'stationGoodsList', [])
      if (!this.form.transportTypeCar) {
        this.wareinit()
        this.form.scene = 'DELIVER'
        this.form.needTransport = 1
        this.form.type = INTYPECODE.order
      }
    },
    wareinit() {
      this.getCustomerList()
      // this.getOptions()
      if (this.isEditPage) {
        this.setDetailWarehouse()
      } else {
        // 获取仓合同
        this.warehouseContract = getWareHouseContract({
          cargoOwnerCode: this.$store.state.user.customerCode
        })
        if (!this.warehouseContract && this.warehouseContract.TRANSPORT.length <= 0) {
          this.form.needTransport = 0
        }
      }
    },
    async getCustomerList() {
      const data = {
        identityIds: [this.$store.state.user.customerId],
        type: 'ORG',
        needCustomerInfo: true,
        needRelation: true,
        carrierTenantId: this.$store.state.user.tenantId
      }
      const params = {
        page: 1,
        size: 200,
      }
      const res = await getCustomerList(data, params)
      const customerCodes = []
      res.records.forEach((e) => {
        if (e.customerInfo) {
          customerCodes.push(e.customerInfo.customerCode)
          if (e.childrenOrg && e.childrenOrg.length > 0) {
            e.childrenOrg.forEach((n) => {
              if (n.customerInfo?.customerCode) {
                customerCodes.push(n.customerInfo?.customerCode)
              }
            })
          }
        } else {
          customerCodes.push(this.$store.state.user.customerCode)
        }
      })
      this.customerCodes = customerCodes
      this.getWareHouse(customerCodes)
    },
    filterList() {
      if (this.shipperCode !== this.$store.state.user.customerCode) {
        INTYPE[1].disabled = true
      } else {
        INTYPE[1].disabled = false
      }
      return INTYPE
    },
    async getWareHouse(customerCodes = null, tenantName = null, flag = false) {
      const data = {
        customerCodes,
        tenantName,
        needExcludeDefaultTenant: true,
        needGroupByTenantId: false,
      }
      const res = await getWareHouse(data)
      const list = res.records.map((e) => {
        return {
          ...e,
          label: `${e.shipperName} - ${e.tenantName}`,
          value: e.tenantId
        }
      })
      // 如果是仓配入库，且入库类型是退货入库，仓库不能选择下级仓库
      if (this.form.scene === warehouseType.in && this.form.type === INTYPECODE.return) {
        const {customerCode} = this.$store.state.user
        this.warehouseList = list.filter((e) => {
          return e.shipperCode === customerCode
        })
      } else {
        this.warehouseList = list
      }
      if (!this.listFlag) {
        this.listFlag = true
      }
      if (flag) {
        this.checkedWarehouse(list[0] || {})
      }
    },
    onSearchWarehouse(tenantName) {
      if (this.form.scene === warehouseType.in) {
        this.getWareHouse(this.customerCodes, tenantName)
      } else {
        const code = this.getCode()
        this.getWareHouse(code, tenantName)
      }
    },
    getCode() {
      return this.$store.state.user.customerCode ? [this.$store.state.user.customerCode] : null
    },
    checkedWarehouse(data) {
      this.$set(this.form, 'deliverWarehouseCode', data.value)
      this.$set(this.form, 'deliverWarehouseName', data.tenantName)
      this.$set(this.form, 'defultName', data.label)
      this.$set(this.form, 'selectWarehouseid', data.id)
      this.$set(this.form, 'customerCode', data.shipperCode)
      this.$set(this.form, 'customerId', data.customerId)
      this.$set(this.form, 'customerName', data.tenantName)
      this.shipperCode = data.shipperCode
      this.form.stationGoodsList = []
      if(this.isDischarge){
        this.$set(this.form, 'endStation', this.form.endStation.map(item=>({...item,stationGoodsList:[]})))
      }
    },
    removeData() {
      this.form.defultName = ''
      this.form.deliverWarehouseCode = ''
    },
    authSuccess() {
      this.$router.push('/authentication')
    },
    isTypeChange(val) {
      this.tabsChange()
      this.form.productType = val
      this.wisdomMileage = false
      this.first = true
      this.isWithinTheContract = true
      this.standLineFlag = true
      this.standAudioFlag = true
      this.removePrice()
      this.transportType = val === standardType.CP003 ? TransportType.RUCKLOAD : TransportType.BREAK_BULK
      // tab切换 有城配才有智能策略
      // if (this.form.endStation[0].address && this.form.startStation.address && (this.filterstand().includes(standardType.CP003) || this.filterstand().includes(standardType.CP004))) {
      //   // 计算里程智能策略
      //   this.getDistance({})
      // }
      if (this.tenantFlag) {
        if (this.productCode === standardType.CP002) {
          // 零担校验所选地址是否在配送范围
          this.zeroStartStation()
        }
        // // 城配 只有点位配 车型只能选择只能调度
        // if(this.filterstand().includes(standardType.CP004) && !this.filterstand().includes(standardType.CP003)){
        //     this.form.carCityType = 1
        // }
        // // 城配 没有车型默认智能调度
        // if(this.productCode !== standardType.CP001 && this.productCode !== standardType.CP002 && !this.filterFeeItem(elementsCode.CARTYPE)){
        //     this.form.carCityType = 1
        // }
      }
      this.changeTab()
      this.$refs.orderForm.validateField('selectCode')
    },
    isCarChange() {
      this.form.carTypeName = ''
      this.form.carTypeId = ''
      this.wisdomMileage = false
      if (this.form.carCityType === carCityTypeNum) {
        this.getCarType()
      } else {
        this.form.carTypeName = ''
        this.form.carTypeId = ''
        this.form.carNorms = ''
        this.form.carLength = ''
      }
      // if (this.form.endStation[0].address && this.form.startStation.address && (this.filterstand().includes(standardType.CP003) || this.filterstand().includes(standardType.CP004))) {
      //   // 计算里程智能策略
      //   this.getDistance({})
      // }
    },
    filterCode() {
      return this.productCode === standardType.CP001 || this.productCode === standardType.CP002
    },
    filterCar() {
      if (this.productCode !== standardType.CP001 && this.productCode !== standardType.CP002 && this.form.carCityType === 1) {
        return false
      }
      return true
    },
    toCity() {
      this.$emit('changeCityTab')
      this.visible = false
    },
    toSpecial() {
      this.$emit('changeTab', this.cityFlag)
      this.specialFlag = false
    },
    removePrice() {
      this.form.estimatePrice = ''
    },
    async zeroEndStation() {
      if (!this.tenantFlag) return
      let endflag = true
      this.form.endStation.forEach((e) => {
        if (!e.cityCode) {
          endflag = false
        }
      })
      if (endflag && this.form.startStation.address) {
        this.form.endStation.forEach(async (e, i) => {
          const res = await getZeroEnd({
            startCityCode: this.form.startStation.cityCode,
            endCityCode: e.cityCode
          })
          if (!res) {
            this.$message.warning('当前区域未开通零担业务')
            this.$set(this.form.endStation, i, {
              ...END_STATION,
              stationGoodsList: [{...GOODS}]
            })
          }
        })
      }
      if (this.isPretend && endflag) {
        // 多装多卸 多个起始地
        const cityCodes = []
        this.form.pretendStation.forEach((pre) => {
          if (pre.address) {
            cityCodes.push(pre.cityCode)
          }
        })
        if (cityCodes.length > 0) {
          this.form.endStation.forEach(async (e, i) => {
            const res = await getManyZeroEnd({
              startCityCodes: cityCodes,
              endCityCode: e.cityCode
            })
            if (!res || res.length <= 0) {
              this.$message.warning('当前区域未开通零担业务')
              this.$set(this.form.endStation, i, {
                ...END_STATION,
                stationGoodsList: [{...GOODS}]
              })
            }
          })
        }
      }
    },
    async zeroStartStation() {
      if (!this.tenantFlag) return

      if (this.form.startStation.address) {
        const res = await getZeroStart({
          startCityCode: this.form.startStation.cityCode
        })
        if (!res) {
          this.$message.warning('当前区域未开通零担业务')
          this.$nextTick(() => {
            this.form.startStation = {
              stationId: '',
              contactName: '',
              contactPhone: '',
              expectTime: null,
              provinceName: '',
              cityName: '',
              countyName: '',
              address: '',
              defaultAddress: []
            }
          })
        }
      }
    },
    filterstand() {
      return this.standardList.map((e) => {
        return e.productCode
      })
    },
    filertype() {
      const data = this.carTypeList[this.form.carLength]
      // const arr = []
      // data.forEach((e) => {
      //     if(arr.filter((n)=> e.carType === n.carType).length <= 0){
      //         arr.push(e)
      //     }
      // })
      // return arr
      return data
    },
    changePrice() {
      // 一单一议计算总价
      this.totalPrice()
    },
    totalPrice() {
      if (this.form.bidUnit !== bidUnitList[0]) {
        let weight = 0
        let volume = 0

        this.form.endStation.forEach((e) => {
          e.stationGoodsList.forEach((n) => {
            weight += n.weight ? n.weight * 1 : 0
            volume += n.volume ? n.volume * 1 : 0
          })
        })
        if (this.form.bidUnit === bidUnitList[1]) {
          this.form.customerBidCost = this.form.bidPrice * 1 * weight
        } else {
          this.form.customerBidCost = this.form.bidPrice * 1 * volume
        }
      } else {
        this.form.customerBidCost = this.form.bidPrice * 1
      }
    },
    async getPrice() {
      if (!this.isEnablePricing||(this.isLoadingAndUnloadingMuch || this.order.ruyeWhite)) return
      if (!this.isPretend) {
        const params = this.buildParams()
        let flag = true
        let goodsFlag = true
        // 校验目的地取货时间和地址是否输入
        params.endStationList.forEach((e) => {
          if (!e.address || !e.expectTime) {
            flag = false
          }
        })

        // 货品品类时校验
        params.stationGoodsList.forEach((e) => {
          if (!e.skuId) {
            goodsFlag = false
          }
        })

        this.form.endStation.forEach((e) => {
          if (e.stationGoodsList.length <= 0) {
            goodsFlag = false
          }
        })
        if (!goodsFlag) {
          this.removePrice()
          this.isWithinTheContract = true
          return
        }
        if (((params.carTypeId && this.productCode === standardType.CP001) || this.productCode === standardType.CP002) && flag && params.stationGoodsList.length > 0 && params.startStation.address && params.startStation.expectTime) {
          this.upLoading = true
          this.pricing = true
          try {
            params.estimatePrice = ''
            const res = await getPrice(params)
            this.isWithinTheContract = res.isWithinTheContract
            this.upLoading = false
            this.pricing = false
            if (res.isWithinTheContract) {
              this.form.estimatePrice = res.price
            } else {
              this.calculationPrice = res.price
              this.form.estimatePrice = ''
            }
          } catch {
            this.upLoading = false
            this.pricing = false
          }
        } else {
          this.isWithinTheContract = true
          this.removePrice()
        }
      } else {
        // 多装多卸预计费
        const params = this.pretendParams()
        // 过滤没有选择的发货地
        this.noSelect = this.filterpre()
        const noSelectList = this.noSelect.map((e) => {
          return e.stationFullAddress
        })
        const pre = params.startStations.filter((item) => {
          return !noSelectList.includes(item.stationFullAddress)
        })
        if (this.form.pretendStation.length > 1) {
          params.startStations = pre
        }

        let flag = true
        let goodsFlag = true
        // 校验目的地取货时间和地址是否输入
        params.endStations.forEach((e) => {
          if (!e.address || !e.endTime) {
            flag = false
          }
        })
        if (this.form.pretendStation.length > 1) {
          this.form.endStation.forEach((e) => {
            e.stationGoodsList.forEach((item) => {
              // 货品类型 和发货地校验
              if (!item.skuId || !item.startStationAddress) {
                goodsFlag = false
              }
            })
            if (e.stationGoodsList.length <= 0) {
              goodsFlag = false
            }
          })
        }
        if(params.endStations&&params.endStations.length){
          params.endStations.forEach((e) => {
            e.goodsList.forEach((item) => {
              // 货品类型 和发货地校验
              if (!item.skuId || !item.startStationAddress) {
                goodsFlag = false
              }
            })
            if (e.goodsList.length <= 0) {
              goodsFlag = false
            }
          })
        }
        if (!goodsFlag) {
          this.removePrice()
          this.isWithinTheContract = true
          return
        }
        console.log(params,'params',goodsFlag);
        if (((params.carTypeId && this.productCode === standardType.CP001) || this.productCode === standardType.CP002) && flag && params.startStations.length > 0) {
          this.upLoading = true
          this.pricing = true
          try {
            params.estimatePrice = ''
            const res = await getManyPrice({
              ...params,
              cost: null,
            })
            // 多装多卸 多个起始地不走一单一议
            if (this.form.pretendStation.length > 1) {
              this.isWithinTheContract = true
            } else {
              this.isWithinTheContract = res.isWithinTheContract
            }
            this.upLoading = false
            this.pricing = false
            if (res.isWithinTheContract) {
              this.form.estimatePrice = res.price
            } else {
              this.calculationPrice = res.price
              this.form.estimatePrice = ''
            }
          } catch {
            this.upLoading = false
            this.pricing = false
          }

        } else {
          this.isWithinTheContract = true
          this.removePrice()
        }
      }
    },
    async getDistance({index = null, endData = null}) {
      if (this.isEditPage || !this.form.transportTypeCar) return
      const data = []
      if (this.isPretend) {
        if (index) {
          // 多装多卸目的地选择起始地时校验智能策略
          data.push({
            startAddress: this.form.pretendStation[index].address,
            startProvince: this.form.pretendStation[index].provinceName,
            startCity: this.form.pretendStation[index].cityName,
            startLat: this.form.pretendStation[index].lat,
            startLng: this.form.pretendStation[index].lon,
            endAddress: endData.address,
            endProvince: endData.provinceName,
            endCity: endData.cityName,
            endLat: endData.lat,
            endLng: endData.lon,
          })
        } else {
          // 多装多卸 目的地改变时
          this.form.endStation.forEach((e) => {
            if (e.address) {
              this.form.pretendStation.forEach((pre) => {
                if (pre.address) {
                  data.push({
                    startAddress: pre.address,
                    startProvince: pre.provinceName,
                    startCity: pre.cityName,
                    startLat: pre.lat,
                    startLng: pre.lon,
                    endAddress: e.address,
                    endProvince: e.provinceName,
                    endCity: e.cityName,
                    endLat: e.lat,
                    endLng: e.lon,
                  })
                }
              })
            }
          })
        }
      } else {
        this.form.endStation.forEach((e) => {
          if (e.address) {
            data.push({
              startAddress: this.form.startStation.address,
              startProvince: this.form.startStation.provinceName,
              startCity: this.form.startStation.cityName,
              startLat: this.form.startStation.lat,
              startLng: this.form.startStation.lon,
              endAddress: e.address,
              endProvince: e.provinceName,
              endCity: e.cityName,
              endLat: e.lat,
              endLng: e.lon,
            })
          }
        })
      }

      if (data.length > 0) {
        const res = await getDistance({
          strategyType: 'MAX',
          data
        })
        if (res) {
          if (res.distance <= 200 && this.productCode !== standardType.CP003 && this.productCode !== standardType.CP004) {
            this.wisdomMileage = !(res.distance > 200)
            this.tipsText = '预估里程低于200KM，推荐你选择【城配】发货更优惠'
            if (this.first) {
              this.visible = true
              this.first = false
            }
          } else if (res.distance > 200 && (this.productCode === standardType.CP003 || this.productCode === standardType.CP004)) {
            // // 城配时
            // if(this.tenantFlag){
            //     // 平台用户
            //     if(this.form.carCityType === 1 && this.form.endStation.length > 1 && this.filterstand().includes(standardType.CP002) && this.filterstand().includes(standardType.CP004) && !this.form.isLine){
            //         this.wisdomMileage = (res.distance > 200)
            //         if(this.standAudioFlag){
            //             this.specialFlag = true
            //         }
            //         // 有点位配产品 并且有零担产品 不选线路
            //         this.standAudioFlag = false
            //         this.tipsText = '预估里程超过200km，推荐你选择零担发货更优惠'
            //         this.cityFlag = false
            //     } else if(this.filterstand().includes(standardType.CP001) && this.filterstand().includes(standardType.CP003)){
            //         this.wisdomMileage = (res.distance > 200)
            //         if(this.standLineFlag){
            //             this.specialFlag = true
            //         }
            //         // 有区域配产品 并且有专车产品
            //         this.standLineFlag = false
            //         this.tipsText = '预估里程超过200km，推荐你选择专车发货更优惠'
            //         this.cityFlag = true
            //     }
            // } else
            if (this.selectCode === standardType.CP003 && this.filterstand().includes(standardType.CP001)) {
              // 非平台用户
              this.wisdomMileage = (res.distance > 200)
              if (this.standLineFlag) {
                this.specialFlag = true
              }
              // 有区域配产品 并且有专车产品
              this.standLineFlag = false
              this.tipsText = '预估里程超过200km，推荐你选择专车发货更优惠'
              this.cityFlag = true
            } else if (this.selectCode === standardType.CP004 && this.filterstand().includes(standardType.CP002)) {
              // 非平台用户
              this.wisdomMileage = (res.distance > 200)
              if (this.standAudioFlag) {
                this.specialFlag = true
              }
              // 有点位配产品 并且有零担产品
              this.standAudioFlag = false
              this.tipsText = '预估里程超过200km，推荐你选择零担发货更优惠'
              this.cityFlag = false
            }
          } else {
            this.wisdomMileage = false
          }
        }
      }
    },
    orderGoodsTypeChange(value, endStations, endStationIndex) {
      // eslint-disable-next-line no-param-reassign
      endStations.orderGoodsType = value
      if (value === 1) {
        this.form.endStation[endStationIndex].stationGoodsList = [{...GOODS}]
      } else {
        this.form.endStation[endStationIndex].stationGoodsList = []
      }
    },
    onSearchCarType(text) {
      this.carTypeList = this.allCarTypeList.filter((e) => {
        return e.label.includes(text)
      })
    },
    isLineChange(event) {
      // // 零担必须要先输入起始地，根据起始地code查询线路
      // if(this.productCode === standardType.CP002 && !this.form.startStation.address && event.target.value){
      //     this.$message.warning('请先选择起始地，在选择线路')
      //     return
      // }
      if (!event.target.value && this.form.endStation.length <= 0) {
        this.form.endStation = [
          {
            ...END_STATION,
            stationGoodsList: []
          }
        ]
      }
      if (!event.target.value) {
        this.form.lineName = ''
        this.form.lineId = ''
        this.form.lineRemark = ''
      }
      // if (this.form.endStation[0].address && this.form.startStation.address && (this.filterstand().includes(standardType.CP003) || this.filterstand().includes(standardType.CP004))) {
      //   // 计算里程智能策略
      //   this.getDistance({})
      // }
    },
    limitDecimals(value) {
      const reg = /^(-)*(\d+)\.(\d\d\d).*$/;
      return `${value}`.replace(reg, '$1$2.$3');
    },
    createDisabled() {
      if (this.oneMoreOrder) {
        return false
      }
      return this.form.isLine
    },
    filterFeeItem(code) {
      const values = this.standardData.elements.map((e) => {
        return e.code
      })
      return values.includes(code)
    },
    tabsChange() {
      // 产品切换部分数据重置
      this.form.isLine = false
      this.form.lineName = ''
      this.form.lineId = ''
      this.form.carTypeName = ''
      this.form.carTypeId = ''
      this.form.mileageKm = ''
      this.form.needPickUp = false
      this.form.needDelivery = false
      this.form.endStation.forEach(e => {
        e.mileageKm = ''
      })
      this.$nextTick(() => {
        // 切换tab后初始化carTypeId
        if ((this.form.productType === standardType.CP001 || this.filterFeeItem(elementsCode.CARTYPE)) && this.form.productType !== standardType.CP002) {
          this.changeCarType()
        }
      })
      if (this.productCode !== standardType.CP002) {
        this.getCarType()
      }
    },
    changeCarType() {
      if (this.form.carLength) {
        this.form.carNorms = this.carTypeList[this.form.carLength][0].carSettingName
        this.changeCar()
      }
    },
    changeCar() {
      this.carTypeList[this.form.carLength].forEach((e) => {
        if (e.carSettingName === this.form.carNorms) {
          this.form.carTypeName = e.carSettingName
          this.form.carTypeId = e.id
        }
      })
    },
    changeLine(data) {
      this.getStations(data)
    },
    onSearchLine(data) {
      this.getCarLine(data)
    },
    async getCarLine(name = null) {
      const params = {
        size: 100,
        page: 1
      }
      const Methode = this.order.ruyeWhite ? getCarLine : getNoRYCarLine;
      const res = await Methode({
        // status: 1,
        // ownerTenantIds: [this.$store.state.user.tenantId],
        // codes: name ? [name] : null,
        // limit: 1000,
        lineStatus: 'ENABLED',
        customerCode: this.$store.state.user.customerCode,
        needStation: true,
        stationStatus: 'ENABLED',
        lineNameLike: name,
        // createTenantId: this.$store.state.user.tenantId
        createTenantId: this.order.ruyeWhite ? null : this.$store.state.user.tenantId
      }, params)
      this.lineList = res.records.map((e) => {
        return {
          ...e,
          label: `${e.lineCode}-${e.lineName}`,
          value: e.id
        }
      })
    },
    async getStations(data) {
      this.lineTips = false
      const res = await getStations({
        lineId: data.id,
        customerCode: this.$store.state.user.customerCode
      })
      if (!res || res.length <= 0) {
        this.$message.warning('此线路下没有当前货主站点')
        return
      }
      const resdata = []
      const startData = []

      let len = 0
      res.forEach((e) => {
        // 目的地
        if (e.stationType === tationTypeCode.end || e.stationType === tationTypeCode.startEnd) {
          resdata.push(e)
          len += 1
        }
        // 起始地
        if (this.isPretend && e.stationType === tationTypeCode.start || e.stationType === tationTypeCode.startEnd) {
          // 多装多卸不提示起始地目的地相同
          startData.push(e)
        } else if (e.stationType === tationTypeCode.start || e.stationType === tationTypeCode.startEnd && startData.length <= 0) {
          startData.push(e)
          this.lineIipsName = len
          if (e.stationType === tationTypeCode.startEnd) {
            setTimeout(() => {
              this.lineTips = true
            }, 300)
          }
        }
      })

      if (!resdata || resdata.length <= 0) {
        this.$message.warning('该线路没有目的地站点，无法下单')
        return
      }
      if (this.form.isLine) {
        this.form.mileageKm = data.planMile
      }
      this.form.endStation = resdata.map(() => {
        return {
          ...END_STATION,
          stationGoodsList: []
        }
      })
      this.$nextTick(() => {
        this.$set(this.form, 'endStation', resdata.map(station => ({
          stationId: station.stationId,
          stationCode: station.stationCode,
          contactName: station.contacts,
          contactPhone: station.telPhone,
          provinceName: station.provinceName,
          cityName: station.cityName,
          countyName: station.countyName,
          address: station.address,
          expectTime: null,
          mileageKm: (this.form.productType !== this.standardType.CP003 && !this.form.isLine) ? data.planMile : null,
          provinceCode: station.provinceCode,
          cityCode: station.cityCode,
          countyCode: station.countyCode,
          stationGoodsList: [],
          lat: station.latitude,
          lon: station.longitude
        })))
        if (this.isPretend) {
          // 多装多卸起始地选择线路回填
          if (startData.length > 0) {
            const arr = startData.map((start) => {
              const {
                stationId,
                stationCode,
                contacts,
                telPhone,
                provinceName,
                cityName,
                countyName,
                address,
                provinceCode,
                cityCode,
                countyCode,
                latitude,
                longitude
              } = start
              return {
                stationId,
                stationCode,
                contactName: contacts,
                contactPhone: telPhone,
                provinceName,
                cityName,
                countyName,
                address,
                expectTime: null,
                provinceCode,
                cityCode,
                countyCode,
                lat: latitude,
                lon: longitude,
                stationFullAddress: `${provinceName}${cityName}${countyName}${address}`
              }
            })
            this.$set(this.form, 'pretendStation', arr)
          } else {
            this.$set(this.form, 'pretendStation', [START_STATION])
          }
        } else if (startData.length > 0) {
          const {
            stationId,
            stationCode,
            contacts,
            telPhone,
            provinceName,
            cityName,
            countyName,
            address,
            provinceCode,
            cityCode,
            countyCode,
            latitude,
            longitude
          } = startData[0]
          this.$set(this.form, 'startStation', {
            stationId,
            stationCode,
            contactName: contacts,
            contactPhone: telPhone,
            provinceName,
            cityName,
            countyName,
            address,
            expectTime: null,
            provinceCode,
            cityCode,
            countyCode,
            lat: latitude,
            lon: longitude
          })
        } else {
          this.$set(this.form, 'startStation', {
            stationId: '',
            contactName: '',
            contactPhone: '',
            expectTime: null,
            provinceName: '',
            cityName: '',
            countyName: '',
            address: '',
            defaultAddress: []
          })
        }
      })
      this.form.lineName = data.lineName
      this.form.lineRemark = data.lineCode
    },
    async getInterface() {
      const res = await getInterface({})
      const newArr = res.sort((a, b) => {
        return a.productCode.localeCompare(b.productCode)
      })
      this.standardList = newArr || []
      // 非平台用户可以选择城配产品
      this.standardCityList = newArr.filter((e) => {
        return e.productCode === standardType.CP003 || e.productCode === standardType.CP004
      })
      if (this.standardCityList.length > 0 && !this.isEditPage) {
        this.selectCode = this.standardCityList[0].productCode
        if (this.productCode === standardType.CP003 || this.productCode === standardType.CP004) {
          this.changeTab()
        }
      }
    },
    async getCarType() {
      const res = await getStandCarType({
        pageSize: '999'
      })
      const len = Object.keys(res)
      this.carTypeflag = res.length > 0
      this.carTypeList = res;
      // 初试默认值
      [this.form.carLength] = len;
      // this.form.carNorms = res[len[0]][0].carType
      this.form.carNorms = res[len[0]][0].carSettingName
      this.form.carTypeId = res[len[0]][0].id
      // this.form.carTypeName = `${this.form.carLength}-${res[len[0]][0].carType}`
      this.form.carTypeName = res[len[0]][0].carSettingName
      this.allCarTypeList = this.carTypeList;
      if (!this.filterFeeItem(elementsCode.CARTYPE) && this.productCode !== standardType.CP001) {
        this.form.carTypeName = ''
        this.form.carTypeId = ''
        this.form.carNorms = ''
        this.form.carLength = ''
      }
    },
    onSearchProject(value) {
      this.selectAll = false
      this.projectList = this.projectALLData.filter((e) => {
        return e.label.includes(value)
      })
    },
    checkedList(data) {
      this.form.projectName = data.name
    },
    changeTab() {
      this.projectList = []
      this.projectALLData = []
      this.getOrganization()
    },
    async getOrganization(value = null) {
      this.fetchOrganization = false
      const {userId, customerCode} = this.$store.state.user
      let {productCode} = this;
      // 如果是城配，区分区域配和点位配
      if (productCode === standardType.CP003 || productCode === standardType.CP004) {
        productCode = this.selectCode
      }
      if (!productCode) {
        return
      }
      const data = {
        accountId: userId,
        relationType: 'DOWN',
        orgType: 'PROJECT',
        accountType: 'CUSTOMER',
        orgNameLike: value,
        // orgStatus: 'ENABLED',
        status:'ENABLE',
        customerCode,
        productCode,
        source:"OWN"
      }
      const accountData = JSON.parse(localStorage.getItem('accountData'))
      data.relationOrgId = accountData?.id
      const res = await fetchProject(data)
      this.fetchOrganization = true
      if (res && res.length > 0) {
         const normalData=[];
        const disabledData=[]
        const records = res.map(t => ({
          ...t,
          name: t.projectName || t.name,
          code:t.projectCode||t.code
        }))
        records.forEach((e) => {
          let subLabel = ''
          if (e.operationResp?.termName) {
            subLabel = `${e.operationResp.termName}`
          }
           const item= {
            ...e,
            value: `${e.id}`,
            label: e.name,
            subLabel,
            disabled: !e.enableStatus||(e.operationResp&&!e.operationResp.productCode)
          }
          if(item.disabled){
            disabledData.push(item)
          }else{
            normalData.push(item)
          }
        })
         this.projectList= [...normalData,...disabledData]
      } else {
        this.projectList = []
      }
      this.projectALLData = this.projectList
    },
    closeOrder() {
      this.$router.push('/order/manage')
    },
    async init() {
      // 多装多卸白名单
      // const req = await getConfig({
      //     keys: 'support.multi.loading.customer',
      //     appId: 1002
      // })
      // const list = req.configs[0]?.value.split(',') || ''
      // if(list.includes(this.$store.state.user.customerCode)){
      //     this.isPretend = true
      // }
      this.$emit('changeTabStatus',true)
      this.odrNo = this.$route.query.odrNo
      this.oneMoreOrder = !!this.$route.query.oneMoreOrder
      if (!this.oneMoreOrder) {
        this.isEditPage = !!this.odrNo
      }
      // 再来一单并且是企业视角需要请求授信预警
      if (this.isEnterprise && this.oneMoreOrder) {
        this.$emit('showTips')
      }
      if (this.isEditPage || this.oneMoreOrder) {
        if (this.$route.query.isWarehouse) {
         await this.wareinit()
        } else if (!this.isPretend) {
         await this.setDetail()
        } else {
          // 多装多卸编辑
         await this.setPretendDetail()
        }
      } else if (this.productCode !== standardType.CP002) {
        await this.getCarLine()
      }
      this.$emit('changeTabStatus',false)
    },
    async setDetail() {
      const res = await featchOrderDetailUnify({
        unifyOdrNo: this.odrNo
      })
      await this.getCarLine(res.lineName)
      this.startTime = res.startTime || res.startStation?.startTime;
      let cartext = res.carTypeName ? parseFloat(res.carTypeName) : ''
      cartext = cartext ? cartext.toFixed(2) : res.carTypeName
      const endList = res.endStations
      // const endList = res.endStations.filter((end) => {
      //     return end[0].status !== CANCELED
      // })
      this.isLoadingAndUnloadingMuch = res.isLoadingAndUnloadingMuch
      if (res.isLoadingAndUnloadingMuch && !this.oneMoreOrder) {
        this.lineDisbled = true
      }
      this.form = {
        ...res.ext,
        transportTypeCar: true,
        isLoadingAndUnloadingMuch: res.isLoadingAndUnloadingMuch,
        transportType: res.orderType,
        odrChannel: res.odrChannel,
        remark: res.remark,
        projectId: res.projectId,
        projectName: res.projectName,
        parentId: this.accountData.id,
        isLine: res.isLine,
        lineId: '',
        lineName: res.lineName,
        lineRemark: res.lineRemark,
        carTypeName: res.carTypeName,
        carLength: cartext,
        carNorms: res.carTypeName,
        carTypeId: res.carTypeId,
        // carCityType: (this.productCode === standardType.CP003 || this.productCode === standardType.CP004) && !res.carTypeId ? 1 : 0,
        mileageKm: res.mileageKm,
        needPickUp: res.needPickUp,
        needDelivery: res.needDelivery,
        productType: this.$route.query.productCode,
        crmNumber: this.oneMoreOrder ? '' : res.crmNumber,
        bidPrice: res.negotiationBid?.bidPrice,
        bidUnit: res.negotiationBid?.bidUnit,
        customerBidCost: res.negotiationBid?.customerBidCost,
        autoConfirm: res.negotiationBid?.autoConfirm,
        pretendStation: [{...START_STATION}],
        startStation: {
          stationId: res.startStations[0].stationId,
          stationName: res.startStations[0].stationName,
          stationCode: res.startStations[0].stationCode,
          contactName: res.startStations[0].contactName,
          contactPhone: res.startStations[0].contactPhone,
          expectTime: this.oneMoreOrder ? '' : moment(res.startStations[0].startTime),
          provinceName: res.startStations[0].provinceName,
          cityName: res.startStations[0].cityName,
          countyName: res.startStations[0].countryName,
          provinceCode: res.startStations[0].provinceCode,
          cityCode: res.startStations[0].cityCode,
          countyCode: res.startStations[0].countryCode,
          address: res.startStations[0].stationAddress,
          lat: res.startStations[0].latitude,
          lon: res.startStations[0].longitude
        },
        endStation: endList.map(station => {
          return ({
            id: station[0].id,
            stationId: station[0].stationId,
            stationName: station[0].stationName,
            stationCode: station[0].stationCode,
            contactName: station[0].contactName,
            contactPhone: station[0].contactPhone,
            provinceName: station[0].provinceName,
            cityName: station[0].cityName,
            countyName: station[0].countryName,
            address: station[0].stationAddress,
            expectTime: this.oneMoreOrder ? '' : moment(station[0].reachTime),
            // crmNumber: res.crmNumber,
            // mileageKm: res.mileageKm ? res.mileageKm : null,
            mileageKm: station[0].mileageKm,
            provinceCode: station[0].provinceCode,
            cityCode: station[0].cityCode,
            countyCode: station[0].countryCode,
            orderGoodsType: station[0].orderGoodsType,
            lat: station[0].latitude,
            lon: station[0].longitude,
            stationGoodsList: station[0].stationGoodsList.map(goods => {
              let flags = false
              if (goods.temperatureZone && goods.temperatureZone.includes('~')) {
                flags = true
              }
              const {skuId, skuCode, skuName, weight, volume, goodsValue, number, ext, id} = goods
              return ({
                id,
                skuId,
                skuCode,
                skuName,
                weight,
                volume,
                skuUnit: ext?.goodsUnit,
                goodsValue,
                number,
                skuNorms: goods.skuNorms,
                temperatureZone: flags ? '自定义温区' : goods.temperatureZone,
                hightemp: flags ? Number(goods.temperatureZone.split('~')[1] || 0) : '',
                lowtemp: flags ? Number(goods.temperatureZone.split('~')[0] || 0) : '',
              })
            })
          })
        })
      }
      this.nextTick(res)
    },
    nextTick(res) {
      this.$nextTick(() => {
        this.form.lineId = res.lineId
        this.selectCode = this.$route.query.productCode
        if (this.oneMoreOrder) {
          this.getPrice()
          // 车型不存在时 默认选中第一个
          const {carLength, carNorms} = this.form
          if ((carLength && (!this.carTypeList[carLength] || this.carTypeList[carLength].filter((e) => {
            return e.carSettingName === carNorms
          }).length <= 0))) {
            this.getCarType()
          }
          // 所选线路不存在时
          if (this.lineList.filter((e) => {
            return e.id === this.form.lineId
          }).length <= 0) {
            this.form.lineId = ''
            this.form.isLine = false
            this.form.lineName = ''
            this.form.lineRemark = ''
          }
        }
        // 再来一单时项目不存在，默认选中第一条
        if (this.projectList.filter((e) => {
          return e.value === this.form.projectId
        }).length <= 0) {
          if (this.oneMoreOrder) {
            this.form.projectId = this.projectList[0]?.value || ''
            this.form.projectName = this.projectList[0]?.label || ''
          } else {
            this.form.projectId = ''
            this.form.projectName = ''
          }
        }
        // this.getOrganization()
      })
    },
    async setPretendDetail() {
      // 多装多卸编辑数据处理
      const res = await featchOrderDetailUnify({
        unifyOdrNo: this.odrNo
      })
      await this.getCarLine(res.lineName)
      let cartext = res.carTypeName ? parseFloat(res.carTypeName) : ''
      cartext = cartext ? cartext.toFixed(2) : res.carTypeName
      // 已取消目的地过滤
      const endList = []
      const starAddrList = []
      res.endStations.forEach((e) => {
        const arr = []
        e.forEach((item) => {
          if (this.oneMoreOrder) {
            arr.push(item)
            item.stationGoodsList.forEach((goods) => {
              if (!starAddrList.includes(goods.startStationId)) {
                starAddrList.push(goods.startStationId)
              }
            })
          } else if (item.status !== CANCELED) {
            arr.push(item)
            item.stationGoodsList.forEach((goods) => {
              if (!starAddrList.includes(goods.startStationId)) {
                starAddrList.push(goods.startStationId)
              }
            })
          }
        })
        if (arr.length > 0) {
          endList.push(arr)
        }
      })
      // 已取消 未被选择的起始地
      const startList = [];
      res.startStations.forEach((e) => {
        if (starAddrList.includes(e.stationId)) {
          startList.push(e)
          this.startNum.push(e.stationAddress)
        }
      })

      // const endList = res.endStations.filter((end) => {
      //     return end.status !== CANCELED
      // })
      this.isLoadingAndUnloadingMuch = res.isLoadingAndUnloadingMuch
      this.lineDisbled = true
      this.form = {
        ...res.ext,
        transportTypeCar: true,
        isLoadingAndUnloadingMuch: res.isLoadingAndUnloadingMuch,
        transportType: res.orderType,
        odrChannelCode: res.odrChannel,
        odrChannel: res.odrChannel,
        orderLabel: res.orderLabel,
        remark: res.remark,
        projectId: res.projectId,
        projectName: res.projectName,
        parentId: this.accountData.id,
        isLine: res.isLine,
        lineId: '',
        lineName: res.lineName,
        lineRemark: res.lineRemark,
        carTypeName: res.carTypeName,
        carLength: cartext,
        carNorms: res.carTypeName,
        carTypeId: res.carTypeId,
        // carCityType: (this.productCode === standardType.CP003 || this.productCode === standardType.CP004) && !res.carTypeId ? 1 : 0,
        mileageKm: res.mileageKm,
        needPickUp: res.needPickUp,
        needDelivery: res.needDelivery,
        productType: this.$route.query.productCode,
        crmNumber: this.oneMoreOrder ? '' : res.crmNumber,
        bidPrice: res.negotiationBid?.bidPrice,
        bidUnit: res.negotiationBid?.bidUnit,
        customerBidCost: res.negotiationBid?.customerBidCost,
        autoConfirm: res.negotiationBid?.autoConfirm,
        startStation: {
          stationId: '',
          contactName: '',
          contactPhone: '',
          expectTime: null,
          provinceName: '',
          cityName: '',
          countyName: '',
          address: '',
          defaultAddress: []
        },
        pretendStation: startList.map((startStations) => {
          return {
            stationId: startStations.stationId,
            stationName: startStations.stationName,
            stationCode: startStations.stationCode,
            contactName: startStations.contactName,
            contactPhone: startStations.contactPhone,
            expectTime: this.oneMoreOrder ? '' : moment(startStations.startTime),
            expectTimeLeft:[moment(startStations.startTime).format('HH:mm:ss'),moment(endList[0].expectTime).format('HH:mm:ss')],
            provinceName: startStations.provinceName,
            cityName: startStations.cityName,
            countyName: startStations.countryName,
            provinceCode: startStations.provinceCode,
            cityCode: startStations.cityCode,
            countyCode: startStations.countryCode,
            address: startStations.stationAddress,
            lat: startStations.latitude,
            lon: startStations.longitude
          }
        }),
        endStation: endList.map(station => {
          const goodsList = []
          station.forEach((goodsItem) => {
            // 过滤已取消的订单货品
            // if(goodsItem.status !== CANCELED){
            goodsList.push(...goodsItem.stationGoodsList)
            // }
          })
          return ({
            id: station.id,
            stationId: station[0].stationId,
            stationName: station[0].stationName,
            stationCode: station[0].stationCode,
            contactName: station[0].contactName,
            contactPhone: station[0].contactPhone,
            provinceName: station[0].provinceName,
            cityName: station[0].cityName,
            countyName: station[0].countryName,
            address: station[0].stationAddress,
            expectTime: this.oneMoreOrder ? '' : moment(station[0].reachTime),
            expectTimeLeft: [moment(station[0].reachTime).format('HH:mm:ss')],
            // crmNumber: res.crmNumber,
            // mileageKm: res.mileageKm ? res.mileageKm : null,
            mileageKm: station[0].mileageKm,
            provinceCode: station[0].provinceCode,
            cityCode: station[0].cityCode,
            countyCode: station[0].countryCode,
            orderGoodsType: station[0].orderGoodsType,
            lat: station[0].latitude,
            lon: station[0].longitude,
            stationGoodsList: goodsList.map(goods => {
              let flags = false
              if (goods.temperatureZone && goods.temperatureZone.includes('~')) {
                flags = true
              }
              const {
                skuId,
                skuCode,
                skuName,
                weight,
                volume,
                goodsValue,
                number,
                ext,
                id,
                startStationId,
                odrNo
              } = goods
              const startAddress = res.startStations.filter((str) => {
                return str.stationId === startStationId
              })
              return ({
                id,
                skuId,
                skuCode,
                skuName,
                weight,
                volume,
                skuUnit: ext?.goodsUnit,
                goodsValue,
                number,
                skuNorms: goods.skuNorms,
                temperatureZone: flags ? '自定义温区' : goods.temperatureZone,
                hightemp: flags ? Number(goods.temperatureZone.split('~')[1] || 0) : '',
                lowtemp: flags ? Number(goods.temperatureZone.split('~')[0] || 0) : '',
                shipment: startAddress[0]?.stationAddress,
                startStationAddress: startAddress[0]?.fullAddress,
                orderNo: odrNo,
                goodsLevel: goods.goodsLevel1 ? [goods.goodsLevel1, goods.goodsLevel2, goods.goodsLevel3] : []
              })
            })
          })
        })
      }
      this.nextTick(res)
    },
    async setDetailWarehouse() {
      const res = await getOrderDetail({
        unifyOdrNo: this.odrNo
      })

      const orderMsgResList = res.orderMsgResList?.[0] || {}
      let cartext = orderMsgResList.carLength ? parseFloat(orderMsgResList.carLength) : ''
      cartext = cartext ? cartext.toFixed(2) : ''
      const scene = res.scene.includes(warehouseType.in) ? warehouseType.in : warehouseType.out
      // let operateOptions = []
      // if (res.ext?.operateOptions) {
      //   operateOptions = res.ext?.operateOptions.split(',') || []
      // }
      this.selectCode = res.ext?.productCode
      this.$nextTick(() => {
        const form = {
          ...this.form,
          transportType: orderMsgResList.ext?.transportType || TransportType.BREAK_BULK,
          remark: res.remark,
          transportTypeCar: false,
          // operateOptions,
          productType: res.ext?.productCode,
          crmNumber: res.crmNumber,
          carTypeName: orderMsgResList.carLength,
          carLength: cartext,
          carNorms: orderMsgResList.carLength,
          carTypeId: orderMsgResList.carType,
          // carCityType: this.selectCode === standardType.CP003 ? 0 : 1,
          customerCode: res.deliverCustomerCode || res.storeCustomerCode,
          unifyOrderNo: res.unifyOrderNo,
          needShelves: orderMsgResList.ext?.needShelves || false,
          needHandling: orderMsgResList.ext?.needHandling || false,
          deliverWarehouseCode: res.deliverWarehouseCode || res.storeWarehouseCode,
          deliverWarehouseName: `${res.deliverWarehouseName || res.storeWarehouseName}`,
          defultName: `${res.deliverCustomerName || res.storeCustomerName} - ${res.deliverWarehouseName || res.storeWarehouseName}`,
          startStation: {
            stationId: res.startStationId || '',
            stationName: res.startStationName || '',
            contactName: res.startStationContact || '',
            contactPhone: res.startStationContactPhone || '',
            expectTime: res.startTime ? moment(res.startTime) : null,
            expectTimeLeft:res.startTime?[moment(res.startTime).format('HH:mm:ss')]:[],
            provinceName: res.ext?.startStation?.provinceName,
            cityName: res.ext?.startStation?.cityName,
            countyName: res.ext?.startStation?.countyName,
            provinceCode: res.ext?.startStation?.provinceCode,
            cityCode: res.ext?.startStation?.cityCode,
            countyCode: res.ext?.startStation?.countyCode,
            address: res.ext?.startStation?.address,
          },
          endStation: [{
            id: orderMsgResList.rowid,
            stationId: res.endStationId || '',
            stationName: res.endStationName || '',
            contactName: res.endStationContact || '',
            contactPhone: res.endStationContactPhone,
            expectTime: res.endTime ? moment(res.endTime) : null,
            expectTimeLeft:res.endTime?[moment(res.endTime).format('HH:mm:ss')]:[],
            provinceCode: res.ext?.endStation?.[0]?.provinceCode,
            cityCode: res.ext?.endStation?.[0]?.cityCode,
            countyCode: res.ext?.endStation?.[0]?.countyCode,
            provinceName: res.ext?.endStation?.[0]?.provinceName,
            cityName: res.ext?.endStation?.[0]?.cityName,
            address: res.ext?.endStation?.[0]?.address,
            countyName: res.ext?.endStation?.[0]?.countyName,
          }],
          stationGoodsList: res.unifyOrderGoodsList.map(goods => {
            const flags = goods.temperatureZone.includes('~')
            return {
              skuId: goods.skuId,
              skuCode: goods.skuCode ? goods.skuCode : '',
              skuName: goods.skuName,
              number: goods.planAmount,
              weight: goods.planWeight,
              volume: goods.planVolume,
              skuNorms: goods.skuNorms,
              skuUnit: goods.skuUnit,
              stockBatch: goods.stockBatch || '',
              temperatureZone: flags ? '自定义温区' : goods.temperatureZone,
              hightemp: flags ? Number(goods.temperatureZone.split('~')[1] || 0) : '',
              lowtemp: flags ? Number(goods.temperatureZone.split('~')[0] || 0) : '',
              goodsValue: goods.skuValue ? goods.skuValue : 0,
              // id: scene === warehouseType.out ? goods.id : goods.skuId,
              id: goods.id,
              isOverWarehouse: goods.wmsExt?.isOverWarehouse || '0'
            }
          }),
          planTime: res.planTime ? moment(res.planTime) : null, // 出/入库时间
          type: scene === warehouseType.in ? res.storeTypeCode || INTYPECODE.order : res.deliveryTypeCode || OUTTYPECODE.order, // 出/入库类型
        }
        this.$set(this, 'form', form)
      })
    },
    async onSubmit() {
      this.upLoading = true
      if (this.form.productType === standardType.CP001 && !this.form.carTypeId) {
        this.$message.warning('请选择车型')
        this.upLoading = false
        return
      }
      const {expectTime} = this.form.startStation || {}
      // 编辑情况下需要校验提货时间不能早于当前时间
      // if (this.isEditPage && expectTime && moment(expectTime).valueOf() < moment().valueOf() - 600000) {
      //     this.$message.error('提货时间不得早于当前时间')
      //     this.upLoading = false
      //     return
      // }
      // 编辑时需要检验起始地提货时间不允许早于初始提货时间
      // if(this.isEditPage && expectTime && this.startTime > moment(expectTime).valueOf()) {
      //     this.$message.error('提货时间不允许早于初始提货时间')
      //     this.upLoading = false
      //     return
      // }
      const {endStation} = this.form;
      if (expectTime) {
        let checkTime = false;
        endStation.forEach(item => {
          if (item.expectTime && new Date(item.expectTime) <= new Date(expectTime)) {
            checkTime = true
          }
        })
        if (checkTime) {
          this.$message.error('送达时间不能小于等于取货时间');
          this.upLoading = false;
          return
        }
      }
      // 零担
      if (this.isEnablePricing&&this.productCode === standardType.CP002 && !this.form.estimatePrice && this.tenantFlag&&!this.order.ruyeWhite) {
        this.$message.error('计费异常，请联系业务人员处理');
        this.upLoading = false;
        return
      }

      try {
        // isDischarge:一装多卸白名单  form.transportTypeCar:运输类型为仓配一体
        await this.$refs.orderForm.validate()
        if(this.isOrderDemoVersion){
          // 当前货主属于在"货主端仓下单演示版本名单"内,在提交前弹窗选择结算方式
          this.$refs.settlementModes.show()
        }
        if(this.isDischarge&&!this.form.transportTypeCar){
          // 一装多卸
          await this.onceLoadMultipleUnload();
        }else{
          await this.submitOrder()
        }
      } catch {
        this.upLoading = false
        this.errorScroll()
      }
    },
    async onceLoadMultipleUnload(){
      // 一装多卸
        const params = this.buildParamsWarehouse()
         const goodsList = [];
            params.endStation.forEach(item=>{
              if(item.stationGoodsList&&item.stationGoodsList.length){
                goodsList.push(...item.stationGoodsList.map(child=>({...child,stationId:item.stationId,stationFullAddress:item.stationFullAddress})))
              }
            })
          params.stationGoodsList = goodsList;
          const {endStation,endStationList,startStation,...restParams}=params;
           const endList=endStationList.map(item=>({...item,contacts:item.contactName,telPhone:item.contactPhone}))
           const start={...startStation,contacts:startStation.contactName,telPhone:startStation.contactPhone}
          const data={
            ...restParams,
            startStation:start,
            endStationList:params.needTransport?endList:[endList[0]],
          }
        if (this.isEditPage) {
          const res = await updateWarehouseOrder({
            ...data,
            unifyOrderNo: this.odrNo
          })
          this.successMessage(res)
          return
        }
        const res = await createWarehouseMultipleOrder(data)
        this.successMessage(res)
    },
    errorScroll() {
      const errDomList = document.querySelectorAll('.has-error')
      if (errDomList[0]) {
        errDomList[0].scrollIntoView({behavior: "smooth", block: "center"});
      }
    },
    successMessage(res) {
      if (!res || res.isSuccess) {
        this.$message.success(`订单${this.isEditPage ? '编辑' : '创建'}成功`)
        this.$route.meta.canRefresh = true
        if (this.form.transportTypeCar) {
          setTimeout(() => {
            this.$router.push('/order/manage')
            this.upLoading = false
          }, 1000)
        } else {
          setTimeout(() => {
            this.$router.push('/order/warehouseList')
            this.upLoading = false
          }, 1000)
        }
      } else {
        this.upLoading = false
        this.$refs.errBatch.show(res.goodsReq || [], this.form.deliverWarehouseCode)
      }
    },
    filterpre() {
      // 多装多卸 校验起始地是不是都被选中的
      const arr = this.form.pretendStation.map((e) => {
        return {
          ...e,
          isSelect: false,
        }
      })
      this.form.endStation.forEach((e) => {
        e.stationGoodsList.forEach((goods) => {
          arr.forEach((item, index) => {
            if (item.address === goods.shipment) {
              arr[index].isSelect = true
            }
          })
        })
      })
      // 未被选择的起始地
      return arr.filter((e) => {
        return !e.isSelect
      })
    },
    async submitOrder() {
      if (this.isPretend && this.form.transportTypeCar) {
        const noSelect = this.filterpre()
        // 起始地个数大于1 且有未选中的
        if (this.form.pretendStation.length > 1 && noSelect && noSelect.length > 0) {

          this.noSelect = noSelect
          this.noPretedSelect = true
        } else {
          this.noSelect = []
          this.submitPretend()
        }
      } else if (this.form.transportTypeCar) {
        const params = this.buildParams()
        if (this.isEditPage) {
          await updateStandardOrder({
            ...params,
            // mileageKm: params.endStationList[0].mileageKm || 0,
            unifyOdrNo: this.odrNo
          })
          this.successMessage()
          return
        }
        params.odrChannel = odrChannel
        await createStandardOrder(params)
        this.successMessage()
      } else {
        const params = this.buildParamsWarehouse()
        if (this.isEditPage) {
          const res = await updateWarehouseOrder({
            ...params,
            unifyOrderNo: this.odrNo
          })
          this.successMessage(res)
          return
        }
        const res = await createWarehouseOrder(params)
        this.successMessage(res)
      }
    },
    async submitPretend() {
      const preList = JSON.parse(JSON.stringify(this.form.pretendStation))
      const noSelectList = this.noSelect.map((e) => {
        return e.stationFullAddress
      })
      this.form.pretendStation = preList.filter((item) => {
        return !noSelectList.includes(item.stationFullAddress)
      })
      this.noPretedSelect = false
      // 多装多卸下单和编辑
      const params = this.pretendParams()
      const canSubmit = this.getCanSubmit(params)
      if (!canSubmit) {
        this.$message.error('请填写货品品类重量或者体积')
        this.upLoading = false
        return
      }
      if (this.order.ruyeWhite) {
        params.pricing = true
      }
      params.odrChannel = odrChannel;
      if(!this.isEnablePricing){
        // 预计费关闭后加上negotiationType参数
        params.negotiationType = 'NONNEGOTIABLE';
      }
      try {
        if (this.isEditPage) {
          await updateStandardEditUnify({
            ...params,
            unifyOrderNo: this.odrNo
          })
          this.successMessage()
          return
        }
        await createManyStandardOrder(params)
        this.successMessage()
      } catch {
        this.upLoading = false
      }
    },
    getCanSubmit(params) {
      let canSubmit = true
      params.endStations.forEach(end => {
        if (end.orderGoodsType === 1) {
          end.goodsList.forEach(good => {
            if (!Number(good.planVolume, 10) && !Number(good.planWeight, 10)) {
              canSubmit = false
            }
          });
        }
      })
      return canSubmit
    },
    pretendParams() {
      // 多装多卸提交数据处理
      const {endStation, startStation, pretendStation,mileageKm,crmNumber, ...otherParams} = this.form
      let {productType, projectId, projectName} = this.form
      const endStationList = []
      const startStationList = []
      const customeField = this.setCustomeFields({mileageKm,crmNumber})
      endStation.forEach(item => {
        const {stationGoodsList, ...otherEndStation} = item
        endStationList.push({
          ...otherEndStation,
          stationContact: item.contactName,
          stationContactPhone: item.contactPhone,
          stationAddress: item.address,
          goodsList: stationGoodsList.map(goods => {
            let startStationAddress = ''
            if (pretendStation.length > 1) {
              startStationAddress = goods.startStationAddress
            } else {
              startStationAddress = pretendStation[0].stationFullAddress ? pretendStation[0].stationFullAddress : `${pretendStation[0].provinceName}${pretendStation[0].cityName}${pretendStation[0].countyName}${pretendStation[0].address}`
            }
            return {
              ...goods,
              temperatureZone: goods.temperatureZone === '自定义温区' ? `${goods.lowtemp || ''}~${goods.hightemp || ''}` : goods.temperatureZone,
              skuUnit: goods.skuUnit || '件',
              planAmount: goods.number,
              planWeight: goods.weight,
              planVolume: goods.volume,
              skuValue: goods.goodsValue,
              startStationAddress,
            }
          }),
          endTime: moment(otherEndStation.expectTime).valueOf()
        })
      });

      pretendStation.forEach((item) => {
        startStationList.push({
          ...item,
          stationContact: item.contactName,
          stationContactPhone: item.contactPhone,
          stationAddress: item.address,
          startTime: moment(item.expectTime).valueOf()
        })
      })

      // // 城配时
      // if(this.tenantFlag){
      //     // 平台用户
      //     if(this.form.carCityType === 1 && this.form.endStation.length > 1 && this.filterstand().includes(standardType.CP004) && !this.form.isLine){
      //         // 点位配 不选车型 目的地大于1 存在点位配合同 不选择线路
      //         productType = standardType.CP004
      //     } else if(productType !== standardType.CP001 && productType !== standardType.CP002 && this.filterstand().includes(standardType.CP003)){
      //         // 区域配 选择车型
      //         productType = standardType.CP003
      //     }
      // }else if(this.productCode !== standardType.CP001 && this.productCode !== standardType.CP002){
      // productType = this.selectCode
      // }

      if (productType !== 'CP001' && productType !== 'CP002') {
        productType = this.selectCode
      }

      return {
        ...otherParams,
        ...customeField,
        cost: otherParams.estimatePrice,
        lineId: otherParams.isLine ? otherParams.lineId : '',
        productType,
        projectId,
        projectName,
        startStations: startStationList,
        endStations: endStationList,
        scene: 'TRANSPORT_ONLY'
      }
    },
    setCustomeFields(data){
      const params = {}
      Object.keys(data).forEach(item=>{
        if(this.isShowCustomeField(ORDER_CUSTOME_FIELDS[item])){
          params[item] = data[item]
        }
      })
      return params
    },
    buildParams() {
      const {endStation, startStation,mileageKm,crmNumber, ...otherParams} = this.form
      let {productType} = this.form
      const endStationList = []
      const goodsList = []
      const customeField = this.setCustomeFields({mileageKm,crmNumber})
      endStation.forEach(item => {
        const {stationGoodsList, ...otherEndStation} = item
        const {provinceName, cityName, countyName, address} = otherEndStation
        const stationFullAddress = `${provinceName}${cityName}${countyName}${address}`

        endStationList.push({
          ...otherEndStation,
          expectTime: moment(otherEndStation.expectTime).valueOf()
        })

        stationGoodsList.forEach(goods => {
          goodsList.push({
            ...goods,
            temperatureZone: goods.temperatureZone,
            skuUnit: goods.skuUnit || '件',
            stationFullAddress,
          })
        })
      });
      // // 城配时
      // if(this.tenantFlag){
      //     // 平台用户
      //     if(this.form.carCityType === 1 && this.form.endStation.length > 1 && this.filterstand().includes(standardType.CP004) && !this.form.isLine){
      //         // 点位配 不选车型 目的地大于1 存在点位配合同 不选择线路
      //         productType = standardType.CP004
      //     } else if(productType !== standardType.CP001 && productType !== standardType.CP002 && this.filterstand().includes(standardType.CP003)){
      //         // 区域配 选择车型
      //         productType = standardType.CP003
      //     }
      // }else if(this.productCode !== standardType.CP001 && this.productCode !== standardType.CP002){
      // productType = this.selectCode
      // }

      if (productType !== 'CP001' && productType !== 'CP002') {
        productType = this.selectCode
      }

      return {
        ...otherParams,
        ...customeField,
        lineId: otherParams.isLine ? otherParams.lineId : '',
        productType,
        startStation: {
          ...startStation,
          expectTime: moment(startStation.expectTime).valueOf()
        },
        endStationList,
        endStation: endStationList[0],
        stationGoodsList: goodsList
      }
    },
    buildParamsWarehouse() {
      const {endStation, startStation,mileageKm,crmNumber, ...otherParams} = this.form
      const endStationList = []
      const customeField = this.setCustomeFields({mileageKm,crmNumber})
      this.form.storeWarehouseCode = this.form.deliverWarehouseCode
      const warehouse = this.warehouseList.filter(item => (item.value === this.form.storeWarehouseCode && item.shipperCode === this.form.customerCode))
      endStation.forEach(item => {
        const {...otherEndStation} = item
        endStationList.push({
          ...otherEndStation,
          expectTime: moment(otherEndStation.expectTime).valueOf()
        })
      });
      const stationGoodsList = this.form.stationGoodsList.map(item => {
        const station = item
        station.stationId = endStation[0].stationId
        station.stationFullAddress = endStation[0].stationFullAddress
        return item
      })
      const test = {
        ...otherParams,
        ...customeField,
        stationGoodsList,
        needTransport: otherParams.needTransport,
        startStation: {
          ...startStation,
          expectTime: moment(startStation.expectTime).valueOf()
        },
        scene: scenceType[this.form.scene][otherParams.needTransport], // 根据订单类型和是否需要运输组装scene
        endStationList,
        planTime: moment(otherParams.planTime).valueOf()
      }
      // 纯入库且类型不是退货入库不传起始地和目的地信息
      if (test.scene === SCENE.STORE_ONLY && otherParams.type !== INTYPECODE.return) {
        test.startStation = undefined
        // test.endStationList = undefined
        // 纯出库不传起始地信息
      } else if (test.scene === SCENE.DELIVER_ONLY) {
        test.startStation = undefined
      }
      // 入库时，不传出库仓库
      if (this.form.scene === warehouseType.in) {
        test.storeWarehouseName = warehouse[0]?.tenantName
        test.storeCustomerCode = warehouse[0]?.shipperCode
        test.storeCustomerName = warehouse[0]?.shipperName
        test.deliverWarehouseCode = undefined
        test.deliverWarehouseName = undefined
        test.storeTypeCode = otherParams.type
        // 如果是入库不含运输且类型为退货入库，目的地信息为空
        if (this.form.needTransport !== 1 && otherParams.type === INTYPECODE.return) {
          test.endStation = undefined
          test.endStationList = undefined
        }
        // 出库时，不传入库仓库
      } else {
        test.deliverWarehouseName = warehouse[0]?.tenantName
        test.deliverCustomerCode = warehouse[0]?.shipperCode
        test.deliverCustomerName = warehouse[0]?.shipperName
        test.customerId = warehouse[0]?.customerId
        test.storeWarehouseCode = undefined
        test.storeWarehouseName = undefined
        test.deliveryTypeCode = otherParams.type
        // 如果是出库不需要运输且类型为调拨出库，目的地信息为空
        if (this.form.needTransport !== 1 && (otherParams.type === OUTTYPECODE.transfer || otherParams.type === OUTTYPECODE.transferBetween)) {
          test.endStation = undefined
          test.endStationList = undefined
        }
      }
      return test
    },
    // 添加货品
    onAddGoods(goodsList) {
      goodsList.push({...GOODS})
    },
    // 删除货品
    onDeleteGoods(goodsList, index) {
      goodsList.splice(index, 1)
    },
    onAddWharehouseEndStation() {
      this.form.endStation.push({
        ...END_STATION,
        stationGoodsList: []
      })
      this.form.mileageKm=null;
    },
    // 添加目的地
    onAddEndStation() {
      this.form.endStation.push({
        ...END_STATION,
        stationGoodsList: [{...GOODS}]
      })
      this.form.mileageKm=null;
    },
    // 删除目的地
    onDeleteEndStation(index, end) {
      this.form.endStation.splice(index, 1)
      if (end.address === this.form.startStation.address) {
        this.lineTips = false
      }
      this.form.mileageKm=null;
    },
    // 删除起始地
    onDeleteStartStation(index) {
      this.form.mileageKm=null;
      this.form.pretendStation.splice(index, 1)
    },
    handleAfreshVali(prop) {
      this.$refs.orderForm.validateField(prop)
    },
    handleRefreshAll(){
      this.$refs.orderForm.clearValidate()
    }
  }
}
</script>

<style lang="less" scoped>
.OrderManageCreate-root {
  padding-bottom: 50px;

  .margin-left {
    margin-left: 10px;
  }

  .mileageKmBox {
    /deep/ .ant-form-item-children {
      display: flex;
      align-items: center;
    }

    .orderNumStyle {
      // width: 60% !important;
      flex: 1;
    }

    .ant-form-item {
      margin-bottom: 0 !important;
    }

    .tipsIcon {
      font-size: 16px;
    }
  }
}

.odr-txt {
  position: absolute;
  top: -50px;
  right: 30px;
  z-index: 1;
  color: #666;
}

.align-right {
  margin-left: -30px;
  text-align: right;
  height: 50px;
  // background-color: #f0f2f5;
  background-color: #ffffff;
  box-shadow: 0px -5px 5px -5px rgba(0, 0, 0, 0.2);
  padding-top: 10px;
  box-sizing: border-box;
  padding-right: 30px;
  box-sizing: border-box;

  .close {
    margin-right: 30px;
  }
}

.remark-input {
  width: 500px;
}

/deep/ .ant-space-vertical {
  width: 100%;
}

.radioStyle {
  color: #06b880;
}

.noStyle {
  border: none;
}

/deep/ .ant-calendar-picker {
  // max-width: 302px !important;
  width: 100%;
}

.order-container {
  background: #FFFFFF;
  border-radius: 6px;
  padding: 32px 0px;
  margin-bottom: 24px;
  // .basic-info {
  //     margin-bottom: 50px;
  // }
}

.car-specifications {
  margin: 0;
  text-align: center;
  color: #171717;

  > span {
    font-weight: 500;
    margin-right: 12px;
  }

  .specifications-radio {
    background: #F4F5F6;
    border-radius: 4px;
    height: 48px;
    line-height: 48px;
    padding: 0 6px;

    /deep/ .ant-radio-wrapper {
      color: #A9ABAE;
      margin: 0;
      line-height: 32px;
      padding: 0 12px;
      margin: 8px;

      .ant-radio-inner {
        display: none;
      }

      &:hover {
        color: #06B880;
      }

      &:active {
        color: #029869;;
      }

      &.ant-radio-wrapper-checked {
        background: #06B880;
        border-radius: 4px;
        color: #FFFFFF;
      }

      span.ant-radio + * {
        padding: 0;
      }
    }
  }
}

.block-container {
  background: #FFFFFF;
  border-radius: 6px;
  padding: 32px 0px;
  margin-bottom: 24px;

  > div:not(:first-of-type) {
    margin-top: 50px;
  }

  .title {
    margin-bottom: 25px;
  }
}

.origin-station {
  /deep/ .title-containe .icon {
    background: #06B880;
  }

  .deleteStyle {
    margin: 0 24px;
    color: #F56C6C;

    &:hover {
      cursor: pointer;
    }
  }
}

.destination {
  /deep/ .icon {
    background: #FB9432;
  }

  .deleteStyle {
    margin: 0 24px;
    color: #F56C6C;

    &:hover {
      cursor: pointer;
    }
  }
}

.station-add {
  .ant-btn {
    background: #F2FBF8;
    border: 1px dashed #06B880;
    line-height: 48px;
    height: 48px;
    margin-bottom: 40px;

    &:hover {
      background: #029869;
      border: 1px dashed #029869;
      transition: all 1s;
      color: #FFFFFF;
    }
  }
}

// .startAdd{
//     .ant-btn{
//         margin-bottom: 0;
//     }
// }
.porject-label {
  background: #fff;
  padding: 16px 24px 22px 24px;

  .projectTitle {
    display: flex;
    align-items: center;

    .item-line {
      width: 4px;
      height: 18px;
      background: #06B880;
      border-radius: 2px;
      margin-right: 10px;
    }

    .subtitle {
      font-weight: bold;
      font-size: 16px;
    }
  }

  .content {
    width: 100%;
    height: 40px;

    button {
      margin-right: 15px;
      margin-top: 15px;
    }
  }
}

.carBottom {
  overflow: hidden;
  padding: 0 36px;
  margin-bottom: 50px;
}

// .radioBox{
//     padding-left: 40px;
//     // margin-top: 15px;
//     .lineText{
//         margin-right: 16px;
//     }
// }
.siteBox {
  display: inline-block;
  width: 400px;
  margin: 0 20px 0 0;
}

.lineBox {
  padding: 16px 24px 0 24px;
}

// /deep/ .ant-form-item{
//     margin-bottom: 16px !important;
// }
/deep/ .ant-card-body {
  padding: 24px 24px 2px 24px !important;
}

/deep/ .orderNumStyle {
  max-width: 302px !important;
  width: 100%;
}

.tabStyle {
  margin-bottom: 20px;
}

.CarType {
  margin: 20px 0;
}

.money {
  display: block;
  float: left;
  line-height: 31px;
  padding: 0 24px;
  // margin-left: 250px;
  .total {
    font-size: 14px;
    color: #171717;
  }

  .moneyText {
    font-size: 14px;
    color: #F56C6C;
    margin: 0 5px 0 16px;
  }

  .amount {
    font-size: 24px;
    color: #F56C6C;
  }
}

// .active{
//     margin-left: 70px;
// }
.specialCarTips {
  width: 100%;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  background: #FFFBE6;
  border-radius: 6px;
  padding: 0 17px;
  border: 1px solid rgba(255, 229, 143, 0.5);

  .anticon-exclamation-circle {
    color: #FAAD14;
  }

  .anticon-close {
    float: right;
    margin-top: 13px;

    &:hover {
      cursor: pointer;
    }
  }
}

.intelligence {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  line-height: 30px;

  .anticon-exclamation-circle {
    color: #FAAD14;
    font-size: 21px;
    margin-right: 16px;
    vertical-align: sub;
  }
}

.intellText {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  line-height: 30px;
  margin-top: 20px;
}

.freight {
  .moneyText {
    font-size: 14px;
    color: #F56C6C;
    margin-right: 5px;
  }

  .amount {
    font-size: 24px;
    color: #F56C6C;
  }

  .ytips {
    font-size: 12px;
    color: #606266;
    margin-left: 24px;
  }

  .inputStyle {
    width: 200px;
    margin-right: 16px;
  }

  .automatic {
    font-size: 12px;
    color: #606266;
    margin-left: 14px;
  }

  .surchargebtn {
    font-size: 14px;
    color: #06B880;
    margin-left: 24px;

    &:hover {
      cursor: pointer;
    }
  }
}

::v-deep .ant-tabs-bar {
  margin: 0;
  border-bottom: none;
}

.intelligence {
  margin-left: 24px;
}

.mLeft {
  margin-left: 0;
}

.milStyle {
  margin: 0 10px;
}

.maks {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 100px;
  left: 0;
  z-index: 1000;
}

.noPreteStyle {
  color: red;
}

.projectTitle {
  display: flex;
  align-items: center;

  .item-line {
    width: 4px;
    height: 18px;
    background: #06B880;
    border-radius: 2px;
    margin-right: 10px;
  }

  .subtitle {
    font-weight: bold;
    font-size: 16px;
  }
}

.contrat-container {
  background: #F2FBF8;
  border-radius: 6px;
  border: 1px solid #E7E9EC;
  padding: 12px 24px;
  margin-bottom: 12px;

  img {
    width: 24px;
    height: 24px;
    margin-right: 10px;
  }

  .replaceContract {
    color: #06B880;
    margin-left: 20px;

    &:hover {
      cursor: pointer;
    }
  }

  .contractTitleName {
    font-weight: 500;
    margin-left: 12px;
    font-size: 16px;
  }
}
.zimu_table{
  margin-right: 4px;

}
</style>
